
function themeRoute(path) {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  root = String(root || '/');
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var cleaned = String(path || '').replace(/^\/+/, '');
  var rootClean = root.replace(/^\/+|\/+$/g, '');
  if (rootClean && cleaned.indexOf(rootClean + '/') === 0) {
    cleaned = cleaned.slice(rootClean.length + 1);
  }
  return root + cleaned;
}
function checkoutUrl(discountCode) {
  var url = themeRoute('checkout');
  if (discountCode) url += '?discount=' + encodeURIComponent(discountCode);
  return url;
}
function savedDiscountCode() {
  try {
    var saved = sessionStorage.getItem('oikos_discount') || '';
    if (saved.toUpperCase() === 'KAMOIKOS10') { sessionStorage.removeItem('oikos_discount'); return ''; }
    return saved;
  } catch (e) { return ''; }
}
function singleVariantCheckoutUrl(variantId, quantity, discountCode) {
  var qty = Math.max(1, parseInt(quantity || 1, 10) || 1);
  var url = themeRoute('cart/' + encodeURIComponent(variantId) + ':' + encodeURIComponent(qty));
  if (discountCode) url += '?discount=' + encodeURIComponent(discountCode);
  return url;
}
function isCartPage() {
  return /\/cart\/?$/.test(window.location.pathname || '');
}
function toggleRange() {
  var drawer = document.getElementById('rangeDrawer');
  var btn = document.getElementById('rangeBtn');
  var overlay = document.getElementById('overlay');
  if (!drawer || !overlay) return;
  var isOpen = drawer.classList.contains('open');
  closeAll();
  if (!isOpen) {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
    if (btn) {
      btn.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  }
}
function toggleCart() {
  var drawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('overlay');
  var btn = document.getElementById('cartBtn');
  if (!drawer || !overlay) return;
  var isOpen = drawer.classList.contains('open');
  closeAll();
  if (!isOpen) {
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    refreshCart();
  }
}
function closeAll() {
  if (typeof window.rangeDrawerBack === 'function') window.rangeDrawerBack();
  var rangeDrawer = document.getElementById('rangeDrawer');
  var cartDrawer = document.getElementById('cartDrawer');
  var overlay = document.getElementById('overlay');
  var rangeBtn = document.getElementById('rangeBtn');
  var cartBtn = document.getElementById('cartBtn');
  if (rangeDrawer) { rangeDrawer.classList.remove('open'); rangeDrawer.setAttribute('aria-hidden', 'true'); }
  if (cartDrawer) { cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
  if (overlay) { overlay.classList.remove('open'); }
  if (rangeBtn) { rangeBtn.classList.remove('open'); rangeBtn.setAttribute('aria-expanded', 'false'); }
  if (cartBtn) { cartBtn.setAttribute('aria-expanded', 'false'); }
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeAll();
});
function toggleStockFilter(el) {
  var url = new URL(window.location.href);
  var isActive = el.classList.contains('stock-toggle-on') || el.classList.contains('active') || el.getAttribute('aria-pressed') === 'true' || url.searchParams.get('filter.v.availability') === '1';
  if (isActive) {
    url.searchParams.delete('filter.v.availability');
    el.classList.remove('stock-toggle-on');
    el.classList.remove('active');
    el.setAttribute('aria-pressed', 'false');
  } else {
    url.searchParams.set('filter.v.availability', '1');
    el.classList.add('stock-toggle-on');
    el.classList.add('active');
    el.setAttribute('aria-pressed', 'true');
  }
  url.searchParams.delete('page');
  window.location.href = url.pathname + (url.search ? url.search : '') + url.hash;
}
function toggleFilterGroup(el) {
  var body = el ? el.nextElementSibling : null;
  if (!body) return;
  var isOpen = body.classList.contains('is-open');
  if (isOpen) {
    body.classList.remove('is-open');
    el.classList.remove('is-open');
    el.setAttribute('aria-expanded', 'false');
  } else {
    body.classList.add('is-open');
    el.classList.add('is-open');
    el.setAttribute('aria-expanded', 'true');
  }
}
function toggleDeptGroup(el) {
  var body = el ? el.nextElementSibling : null;
  if (!body) return;
  var isOpen = body.classList.contains('is-open');
  if (isOpen) {
    body.classList.remove('is-open');
    el.classList.remove('is-open');
    el.setAttribute('aria-expanded', 'false');
  } else {
    body.classList.add('is-open');
    el.classList.add('is-open');
    el.setAttribute('aria-expanded', 'true');
  }
}
function toggleAccordion(el) {
  var body = el ? el.nextElementSibling : null;
  if (!body) return;
  var isOpen = body.classList.contains('is-open');
  if (isOpen) {
    body.classList.remove('is-open');
    el.classList.remove('is-open');
    el.setAttribute('aria-expanded', 'false');
  } else {
    body.classList.add('is-open');
    el.classList.add('is-open');
    el.setAttribute('aria-expanded', 'true');
    if (el.id === 'reviewsAccordionTrigger') {
      setTimeout(function() {
        if (window.jdgm && typeof window.jdgm.init === 'function') {
          window.jdgm.init();
        }
        if (window.jdgm && typeof window.jdgm.on === 'function') {
          window.jdgm.on('widget:mount', function() {});
        }
      }, 100);
    }
  }
}
function setResponsiveImage(img, src, alt) {
  if (!img || !src) return;
  img.removeAttribute('srcset');
  img.removeAttribute('sizes');
  if (typeof alt !== 'undefined') img.alt = alt || '';
  img.src = src;
}
var OIKOS_EXTERNAL_IMAGE_BASE = 'https://newimages.broersgroup.com.au/1000x1000';
function getSkuLifestyleUrl(sku) {
  if (!sku) return '';
  var clean = String(sku).trim();
  if (!clean) return '';
  return OIKOS_EXTERNAL_IMAGE_BASE + '/' + encodeURIComponent(clean) + '/' + encodeURIComponent(clean + '-00.jpg');
}
function setImageWithFallback(img, primarySrc, fallbackSrc, alt) {
  if (!img || !primarySrc) return;
  img.onerror = null;
  if (fallbackSrc && fallbackSrc !== primarySrc) {
    img.onerror = function() {
      this.onerror = null;
      setResponsiveImage(this, fallbackSrc, alt || this.alt || '');
    };
  }
  setResponsiveImage(img, primarySrc, alt || img.alt || '');
}
function displayOptionValue(value) {
  if (value === null || typeof value === 'undefined') return '';
  var raw = String(value);
  var compact = raw.toLowerCase().replace(/\s+/g, '').replace(/×/g, 'x').replace(/\*/g, 'x');
  if (window.oikosFramelessMirror && compact.indexOf('multi') !== -1) return 'Frameless';
  if (compact === '2pcx4') return 'Set of 8';
  if (compact === '2pcx3') return 'Set of 6';
  if (compact === '2pcx2') return 'Set of 4';
  return raw;
}
function displayListingText(text) {
  if (!text) return '';
  var out = String(text)
    .replace(/2\s*pc\s*[x×*]\s*4/ig, 'Set of 8')
    .replace(/2\s*pc\s*[x×*]\s*3/ig, 'Set of 6')
    .replace(/2\s*pc\s*[x×*]\s*2/ig, 'Set of 4');
  if (/mirror/i.test(out)) out = out.replace(/\s*[–—-]\s*multi\b/ig, ' - Frameless');
  return out;
}
function oikosOptionLabel(index) {
  var label = document.getElementById('optLabel-' + (index + 1));
  return label ? String(label.textContent || '').replace(/:.*/, '').trim() : '';
}
function oikosFindColourOptionIndex() {
  if (typeof productVariants === 'undefined' || !productVariants || !productVariants.length) return -1;
  var optionCount = (productVariants[0].options || []).length;
  for (var i = 0; i < optionCount; i++) {
    if (/colour|color|variant/i.test(oikosOptionLabel(i))) return i;
  }
  return -1;
}
function oikosShouldShareImageAcrossQuantityOptions(colourIndex) {
  if (typeof productVariants === 'undefined' || !productVariants || !productVariants.length) return false;
  var optionCount = (productVariants[0].options || []).length;
  var nonColourCount = 0;
  for (var i = 0; i < optionCount; i++) {
    if (i === colourIndex) continue;
    nonColourCount++;
    var label = oikosOptionLabel(i).toLowerCase();
    if (!/(quantity|qty|pack|set|piece|pieces|pc|bundle)/i.test(label)) return false;
  }
  return nonColourCount > 0;
}
function oikosQtyRank(value) {
  if (value === null || typeof value === 'undefined') return Infinity;
  var raw = String(value).toLowerCase().trim();
  var compact = raw.replace(/\s+/g, '').replace(/×/g, 'x').replace(/\*/g, 'x');
  if (compact === 'single' || compact === '1pc' || compact === '1piece') return 1;
  if (compact === '2pcx2') return 4;
  if (compact === '2pcx3') return 6;
  if (compact === '2pcx4') return 8;
  var map = {'set of two':2,'set of 2':2,'set of three':3,'set of 3':3,'set of four':4,'set of 4':4,'set of six':6,'set of 6':6,'set of eight':8,'set of 8':8};
  if (map[raw] !== undefined) return map[raw];
  var m = raw.match(/(?:set\s*of\s*)?(\d+)/);
  return m ? parseInt(m[1], 10) : Infinity;
}
function oikosVariantImageRank(variant, colourIndex) {
  var rank = Infinity;
  (variant.options || []).forEach(function(opt, idx) {
    if (idx !== colourIndex) rank = Math.min(rank, oikosQtyRank(opt));
  });
  if (rank === Infinity) {
    var sku = String(variant.sku || '').trim();
    var pack = sku.match(/x(\d+)$/i);
    rank = pack ? parseInt(pack[1], 10) : 1;
  }
  var skuPenalty = /x\d+$/i.test(String(variant.sku || '')) ? 10 : 0;
  var unavailablePenalty = variant.available === false ? 1000 : 0;
  return unavailablePenalty + rank + skuPenalty;
}
function oikosBestImageVariantForSelection(matchedVariant) {
  if (!matchedVariant || typeof productVariants === 'undefined' || !productVariants) return matchedVariant;
  var colourIndex = oikosFindColourOptionIndex();
  if (colourIndex < 0 || !matchedVariant.options || !matchedVariant.options.length) return matchedVariant;
  if (!oikosShouldShareImageAcrossQuantityOptions(colourIndex)) return matchedVariant;
  var colourValue = matchedVariant.options[colourIndex];
  var candidates = productVariants.filter(function(v) {
    return v && v.options && v.options[colourIndex] === colourValue;
  });
  if (!candidates.length) return matchedVariant;
  candidates.sort(function(a, b) {
    return oikosVariantImageRank(a, colourIndex) - oikosVariantImageRank(b, colourIndex);
  });
  return candidates[0] || matchedVariant;
}
var oikosVariantDataCache = null;
function oikosGetVariantData() {
  if (oikosVariantDataCache !== null) return oikosVariantDataCache;
  var el = document.querySelector('.oikos-variant-data');
  if (!el) { oikosVariantDataCache = {}; return {}; }
  var raw = el.getAttribute('data-variants') || '';
  try { oikosVariantDataCache = JSON.parse(raw) || {}; }
  catch(e) { oikosVariantDataCache = {}; }
  return oikosVariantDataCache;
}
function oikosEscapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, function(ch) {
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch];
  });
}
function oikosSetSpecLine(container, key, label, value) {
  if (!container) return;
  var ul = container.querySelector('ul');
  if (!ul) {
    ul = document.createElement('ul');
    container.appendChild(ul);
  }
  var li = ul.querySelector('[data-oikos-spec-row="' + key + '"]');
  if (!li) {
    var legacy = ul.querySelector('[data-oikos-spec="' + key + '"]');
    if (legacy) li = legacy.closest ? legacy.closest('li') : legacy.parentNode;
  }
  if (!value) {
    if (li && li.parentNode) li.parentNode.removeChild(li);
    return;
  }
  if (!li || li.tagName.toLowerCase() !== 'li') {
    li = document.createElement('li');
    ul.appendChild(li);
  }
  li.setAttribute('data-oikos-spec-row', key);
  li.innerHTML = '<strong>' + oikosEscapeHtml(label) + ':</strong> <span data-oikos-spec="' + key + '">' + oikosEscapeHtml(value) + '</span>';
  var duplicates = ul.querySelectorAll('[data-oikos-spec-row="' + key + '"]');
  for (var i = 1; i < duplicates.length; i++) {
    if (duplicates[i] && duplicates[i].parentNode) duplicates[i].parentNode.removeChild(duplicates[i]);
  }
}
function oikosUpdateActiveVariantSpecs(entry) {
  if (!entry) return;
  var spec = document.querySelector('.oikos-active-variant-specs');
  if (!spec) {
    var rte = document.querySelector('.product-accordion .rte') || document.querySelector('.rte');
    if (!rte) return;
    spec = document.createElement('div');
    spec.className = 'oikos-active-variant-specs';
    spec.setAttribute('aria-live', 'polite');
    rte.appendChild(spec);
  }
  spec.innerHTML = '<h4>Selected variant specifications</h4><ul></ul>';
  oikosSetSpecLine(spec, 'size', 'Size', entry.size || '');
  oikosSetSpecLine(spec, 'colour', 'Colour', entry.colour || entry.color || '');
  oikosSetSpecLine(spec, 'dimensions', 'Overall dimensions', entry.dimensions || '');
  oikosSetSpecLine(spec, 'weight_capacity', 'Weight capacity', entry.weight_capacity || '');
}
function oikosApplyVariantDimensions(sku) {
  if (!sku) return;
  var data = oikosGetVariantData();
  var entry = data[sku];
  if (!entry) return;
  var table = document.querySelector('.variant-dims-table');
  if (table) {
    var rows = table.querySelectorAll('tr[data-variant-sku]');
    for (var i = 0; i < rows.length; i++) {
      var rsku = rows[i].getAttribute('data-variant-sku') || '';
      var skuMatched = rsku === sku || rsku.split(';').indexOf(sku) !== -1;
      if (skuMatched) {
        rows[i].style.background = 'rgba(168,149,110,0.10)';
        rows[i].style.borderLeft = '2px solid var(--accent)';
      } else {
        rows[i].style.background = '';
        rows[i].style.borderLeft = '';
      }
    }
  }
  var callout = document.getElementById('oikosActiveDim');
  if (callout && callout.parentNode) callout.parentNode.removeChild(callout);
  oikosUpdateActiveVariantSpecs(entry);
}
function oikosVariantFallbackSrc(variant) {
  if (!variant) return '';
  if (variant.featured_image) return variant.featured_image.src || variant.featured_image;
  if (variant.image) return variant.image.src || variant.image;
  return '';
}
function oikosColourMatchedImageSrc(colourValue) {
  if (!colourValue || typeof productImages === 'undefined' || !productImages || !productImages.length) return '';
  var key = String(colourValue).toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
  if (!key) return '';
  var dash = key.replace(/\s+/g, '-');
  var us = key.replace(/\s+/g, '_');
  var first = key.split(' ')[0];
  var backup = '';
  for (var i = 0; i < productImages.length; i++) {
    var src = String(productImages[i].src || '').toLowerCase();
    var alt = String(productImages[i].alt || '').toLowerCase();
    var hit = src.indexOf(dash) !== -1 || src.indexOf(us) !== -1 || alt.indexOf(key) !== -1;
    if (!hit && first.length > 3 && first !== key) {
      hit = src.indexOf(first) !== -1 || alt.indexOf(first) !== -1;
    }
    if (hit) {
      if (src.indexOf('-01.') === -1 && src.indexOf('_01.') === -1) return productImages[i].src;
      if (!backup) backup = productImages[i].src;
    }
  }
  return backup;
}
function oikosApplyHeroImageForVariant(matchedVariant, selectedColourValue) {
  var mainImg = document.getElementById('mainImg');
  if (!mainImg || !matchedVariant) return false;
  var isDefaultOnly = matchedVariant.options && matchedVariant.options.length === 1 && String(matchedVariant.options[0] || '').toLowerCase() === 'default title';
  if (isDefaultOnly) return false;
  var imageVariant = oikosBestImageVariantForSelection(matchedVariant) || matchedVariant;
  var assignedImg = oikosVariantFallbackSrc(imageVariant) || oikosVariantFallbackSrc(matchedVariant);
  var colourIdx = oikosFindColourOptionIndex();
  var colourValue = selectedColourValue || (colourIdx >= 0 && matchedVariant.options ? matchedVariant.options[colourIdx] : '');
  var colourMatch = oikosColourMatchedImageSrc(colourValue);
  var firstProdImg = (typeof productImages !== 'undefined' && productImages && productImages[0]) ? productImages[0].src : '';
  var altText = (imageVariant.featured_image && imageVariant.featured_image.alt) || imageVariant.title || matchedVariant.title || mainImg.alt || '';
  if (assignedImg) {
    var safetyNet = colourMatch && colourMatch !== assignedImg ? colourMatch : firstProdImg;
    setImageWithFallback(mainImg, assignedImg, safetyNet, altText);
    return true;
  }
  var fallbackImg = colourMatch || firstProdImg;
  if (fallbackImg) {
    setResponsiveImage(mainImg, fallbackImg, altText);
    return true;
  }
  var lifestyleImg = getSkuLifestyleUrl(imageVariant.sku || matchedVariant.sku);
  if (lifestyleImg) {
    setImageWithFallback(mainImg, lifestyleImg, fallbackImg, altText);
    return true;
  }
  if (colourValue && typeof productImages !== 'undefined') {
    var colourKey = String(colourValue).toLowerCase().trim();
    var found = productImages.findIndex(function(img) {
      return img.alt && img.alt.toLowerCase().indexOf(colourKey) !== -1;
    });
    if (found !== -1 && typeof switchImageByIndex === 'function') {
      switchImageByIndex(found);
      return true;
    }
  }
  return false;
}
function changeProductQty(delta) {
  var display = document.getElementById('productQty');
  var input = document.getElementById('quantityInput');
  if (!display) return;
  var current = parseInt(display.textContent) || 1;
  var newVal = Math.max(1, current + delta);
  display.textContent = newVal;
  if (input) { input.value = newVal; }
  oikosRefreshPackageContent();
}

/* ── Package Content & Quantity Specs Dynamic Updater ──────────────────────
   Updates two sections whenever variant or cart qty changes:
   1. "Package Contents" block — rewrites item quantities (both "x1 item" and
      "1 X item" formats, case-insensitive).
   2. "Number of packages: N" line inside Specifications — updates to match
      the selected variant's package count from the oikos-variant-data JSON.

   Key rule: base quantities are stored ONCE on init from the original HTML
   and never re-read from the DOM, preventing compounding on repeated calls.
   ─────────────────────────────────────────────────────────────────────────── */
(function() {

  // ── True item count from SKU ──────────────────────────────────────────────
  function skuTrueCount(sku) {
    if (!sku) return 1;
    var upper = String(sku).toUpperCase();
    var xm = upper.match(/X(\d+)$/);
    var xFactor = xm ? parseInt(xm[1], 10) : 1;
    var basePack = upper.indexOf('2PC') !== -1 ? 2 : 1;
    return xFactor * basePack;
  }

  // ── Get currently selected variant object ─────────────────────────────────
  function currentVariant() {
    var variantSelect = document.getElementById('variantId');
    if (variantSelect && typeof productVariants !== 'undefined') {
      var vid = parseInt(variantSelect.value, 10);
      for (var i = 0; i < productVariants.length; i++) {
        if (productVariants[i].id === vid) return productVariants[i];
      }
    }
    return null;
  }
  function currentVariantSku() {
    var v = currentVariant();
    return v ? (v.sku || '') : '';
  }

  // ── Get package count from oikos-variant-data JSON for this SKU ──────────
  function variantPackageCount(sku) {
    try {
      var el = document.querySelector('.oikos-variant-data[data-variants]');
      if (!el) return null;
      var data = JSON.parse(el.getAttribute('data-variants') || '{}');
      var entry = data[sku];
      if (entry && entry.packages) return parseInt(entry.packages, 10);
    } catch(e) {}
    return null;
  }

  // ── Stored state (set once, never re-read from DOM) ───────────────────────
  var _pkgLines = null;       // Package Content lines
  var _pkgContainer = null;
  var _specsLines = null;     // Specs paragraph lines
  var _specsContainer = null;
  var _baseCount = null;      // smallest variant's true count (computed once)

  // ── Parse a line for quantity pattern, return { prefix, qty, suffix, format }
  // Handles both:
  //   "item x2"       → format 'suffix'  → prefix="item ", qty=2, suffix=""
  //   "2 X item name" → format 'prefix'  → prefix="", qty=2, suffix=" X item name"
  function parseLine(text) {
    if (/package\s+content/i.test(text)) return null;
    // Pattern 1: trailing "x{N}" or "× {N}" (item xN)
    var m1 = text.match(/^(.*?)\s*([x×])\s*(\d+)\s*$/i);
    if (m1) return { prefix: m1[1], sep: m1[2], qty: parseInt(m1[3], 10), format: 'suffix' };
    // Pattern 2: leading "{N} X " (N X item)
    var m2 = text.match(/^(\d+)\s*([xX×])\s+(.+)$/);
    if (m2) return { suffix: m2[3], sep: m2[2], qty: parseInt(m2[1], 10), format: 'prefix' };
    return null;
  }

  function initPackageContent() {
    var rte = document.querySelector('.product-accordion .rte, .rte');
    if (!rte) return false;

    // ── 1. Find Package Content block ───────────────────────────────────────
    var allBold = rte.querySelectorAll('strong, b, h4, h3');
    var pkgHeader = null;
    for (var i = 0; i < allBold.length; i++) {
      if (/package\s+content/i.test(allBold[i].textContent)) { pkgHeader = allBold[i]; break; }
    }
    if (pkgHeader) {
      var headerParent = pkgHeader.closest('p') || pkgHeader.parentElement;
      if (headerParent) {
        _pkgContainer = headerParent;
        var rawHtml = headerParent.innerHTML;
        var htmlLines = rawHtml.split(/<br\s*\/?>/i);
        _pkgLines = htmlLines.map(function(line) {
          var text = line.replace(/<[^>]+>/g, '').trim();
          var parsed = parseLine(text);
          if (parsed) return { isItem: true, html: line, parsed: parsed };
          return { isItem: false, html: line };
        });
      }
    }

    // ── 2. Find Specifications block for "Number of packages" line ──────────
    // Look for the <p> block that contains "Number of packages"
    var allParas = rte.querySelectorAll('p');
    for (var j = 0; j < allParas.length; j++) {
      if (/number\s+of\s+packages/i.test(allParas[j].textContent)) {
        _specsContainer = allParas[j];
        var specsHtml = allParas[j].innerHTML;
        var specsHtmlLines = specsHtml.split(/<br\s*\/?>/i);
        _specsLines = specsHtmlLines.map(function(line) {
          var text = line.replace(/<[^>]+>/g, '').trim();
          if (/number\s+of\s+packages/i.test(text)) {
            // Extract current base number
            var nm = text.match(/:\s*(\d+)/);
            return { isPackages: true, html: line, baseQty: nm ? parseInt(nm[1], 10) : 1 };
          }
          return { isPackages: false, html: line };
        });
        break;
      }
    }

    // ── 3. Compute base count (smallest variant) ────────────────────────────
    if (typeof productVariants !== 'undefined' && productVariants.length) {
      var minCount = 9999;
      productVariants.forEach(function(v) {
        var c = skuTrueCount(v.sku);
        if (c < minCount) minCount = c;
      });
      _baseCount = minCount;
    } else {
      _baseCount = 1;
    }

    return !!(_pkgLines || _specsLines);
  }

  // ── Rewrite quantities ────────────────────────────────────────────────────
  window.oikosRefreshPackageContent = function() {
    if (_pkgLines === null && _specsLines === null) {
      if (!initPackageContent()) return;
    }

    var sku = currentVariantSku();
    var trueCount = skuTrueCount(sku);
    var scaleFactor = (_baseCount && _baseCount > 0) ? (trueCount / _baseCount) : 1;
    var cartQty = parseInt((document.getElementById('productQty') || {}).textContent, 10) || 1;

    // ── Update Package Content lines ────────────────────────────────────────
    if (_pkgLines && _pkgContainer) {
      var newLines = _pkgLines.map(function(entry) {
        if (!entry.isItem) return entry.html;
        var newQty = Math.round(entry.parsed.qty * scaleFactor * cartQty);
        if (entry.parsed.format === 'suffix') {
          // "item x{N}" → replace trailing number
          return entry.html.replace(/([x×]\s*)\d+(\s*)$/i, '$1' + newQty + '$2');
        } else {
          // "{N} X item" → replace leading number
          return entry.html.replace(/^\s*\d+(\s*[xX×]\s*)/, newQty + '$1');
        }
      });
      _pkgContainer.innerHTML = newLines.join('<br>');
    }

    // ── Update "Number of packages" in Specifications ─────────────────────
    if (_specsLines && _specsContainer) {
      // Prefer the exact package count from variant data JSON
      var pkgCount = variantPackageCount(sku);
      if (pkgCount === null) {
        // Fallback: scale the base qty by factor × cartQty
        pkgCount = Math.round((_specsLines.find(function(l) { return l.isPackages; }) || {baseQty: 1}).baseQty * scaleFactor * cartQty);
      } else {
        pkgCount = pkgCount * cartQty;
      }
      var newSpecLines = _specsLines.map(function(entry) {
        if (!entry.isPackages) return entry.html;
        // Replace the number after the colon: "Number of packages: 1" → "Number of packages: 2"
        return entry.html.replace(/(number\s+of\s+packages\s*:\s*)\d+/i, '$1' + pkgCount);
      });
      _specsContainer.innerHTML = newSpecLines.join('<br>');
    }
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function() {
    setTimeout(function() {
      if (initPackageContent()) oikosRefreshPackageContent();
    }, 250);
  });
})();
var _baseProductTitle = null;
var _selectedSize = null;
var _selectedColour = null;
var _selectedMattress = null;
var _selectedQuantity = null; // e.g. "Set of 2", null when Single/no multi-qty
document.addEventListener('click', function(e) {
  var opt = e.target.closest('.swatch-option[data-option-value], .button-option[data-option-value]');
  if (!opt) return;
  if (opt.classList.contains('unavailable')) { e.preventDefault(); return; }
  var idx = parseInt(opt.getAttribute('data-option-index'), 10);
  var value = opt.getAttribute('data-option-value');
  if (isNaN(idx) || typeof selectOption !== 'function') return;
  e.preventDefault();
  selectOption(opt, idx, value);
});
document.addEventListener('keydown', function(e) {
  var opt = e.target.closest && e.target.closest('.swatch-option[data-option-value], .button-option[data-option-value]');
  if (!opt) return;
  if (e.key !== 'Enter' && e.key !== ' ') return;
  e.preventDefault();
  if (opt.classList.contains('unavailable')) return;
  var idx = parseInt(opt.getAttribute('data-option-index'), 10);
  var value = opt.getAttribute('data-option-value');
  if (isNaN(idx) || typeof selectOption !== 'function') return;
  selectOption(opt, idx, value);
});
var _sizeLabelMap = {
  'single':'Single','s':'Single','d':'Double','double':'Double',
  'queen':'Queen','q':'Queen','king single':'King Single','ks':'King Single',
  'king':'King','k':'King','king size':'King',
  '120cm':'120cm','140cm':'140cm','145cm':'145cm','150cm':'150cm','160cm':'160cm',
  '120':'120cm','140':'140cm','145':'145cm','150':'150cm','160':'160cm',
  'single bunk':'Single Bunk','double bunk':'Double Bunk','queen bunk':'Queen Bunk',
  '2pcx2':'Set of 4','2pcx3':'Set of 6','2pcx4':'Set of 8',
};
function getSizeLabelFromValue(val) {
  if (!val) return null;
  var key = val.toLowerCase().trim();
  var compact = key.replace(/\s+/g, '').replace(/×/g, 'x').replace(/\*/g, 'x');
  return _sizeLabelMap[key] || _sizeLabelMap[compact] || null;
}

function isMattressYesValue(value) {
  var v = String(value || '').toLowerCase().trim();
  return v === 'yes' || v === 'with mattress' || v === 'with-mattress' || v === 'with' || v === 'mattress included' || v === 'included';
}
function stripMattressTitleSuffix(title) {
  return String(title || '').replace(/\s*(?:[-–—]\s*)?(?:with|without)\s+mattress\s*$/i, '').trim();
}
function buildPageTitle() {
  if (_baseProductTitle === null) return;
  var titleEl = document.querySelector('.product-title');
  if (!titleEl) return;
  var base = _baseProductTitle;
  var parts = ['Oikiture'];
  var rest = base.startsWith('Oikiture ') ? base.slice(9) : base;
  if (_selectedSize) {
    var sl = getSizeLabelFromValue(_selectedSize);
    if (sl) {
      rest = sl + ' ' + rest;
    }
  }
  var full = (base.startsWith('Oikiture') ? 'Oikiture ' : '') + rest;
  if (!base.startsWith('Oikiture')) full = base;
  full = stripMattressTitleSuffix(full);
  if (_selectedColour) {
    var suffix = getColourSuffix(_selectedColour);
    if (suffix && full.toLowerCase().indexOf(suffix.toLowerCase()) === -1) full = full + ' - ' + suffix;
  }
  full = stripMattressTitleSuffix(full);
  if (isMattressYesValue(_selectedMattress)) {
    full = full + ' with Mattress';
  }
  // Append quantity suffix when a multi-unit option is selected
  // Strip any existing quantity suffix first to avoid duplication
  full = full.replace(/\s*\(Set of \d+\)\s*$/i, '').trim();
  if (_selectedQuantity) {
    // If the base title already encodes a set size (e.g. "Set of 2 Rattan Dining Chairs"),
    // replace that inline number rather than appending, to keep the title clean
    var inlineSuffix = full.replace(/Set of \d+/i, _selectedQuantity);
    if (inlineSuffix !== full) {
      full = inlineSuffix;
    } else {
      // No inline set-of found — just append as a suffix
      full = full + ' (' + _selectedQuantity + ')';
    }
  }
  titleEl.textContent = displayListingText(full);
}
var _colourSuffixMap = {
  'black':'Black','matte black':'Black','charcoal':'Charcoal','gunmetal':'Gunmetal',
  'white':'White','cream':'Cream','off white':'White','pearl':'White','chalk':'White',
  'boucle white':'White','cloud white':'White',
  'beige':'Beige','sand':'Beige','linen':'Linen','taupe':'Taupe','greige':'Greige',
  'stone':'Stone','champagne':'Champagne','ivory':'Ivory','oatmeal':'Oatmeal',
  'grey':'Grey','gray':'Grey','silver':'Silver','light grey':'Light Grey',
  'dark grey':'Dark Grey','slate':'Slate','charcoal grey':'Charcoal',
  'natural':'Natural','rattan':'Rattan','bamboo':'Natural','timber':'Timber',
  'wood':'Wood','pine':'Pine','oak':'Oak','walnut':'Walnut','brown':'Brown',
  'mocha':'Brown','coffee':'Brown','dark brown':'Dark Brown','chocolate':'Brown',
  'copper':'Copper','bronze':'Bronze','rust':'Rust','terracotta':'Terracotta',
  'gold':'Gold','golden':'Gold','brass':'Brass',
  'green':'Green','emerald':'Green','sage':'Sage','dark green':'Dark Green',
  'forest green':'Forest Green','olive':'Olive','teal':'Teal',
  'pink':'Pink','blush':'Pink','rose':'Rose','dusty pink':'Pink','baby pink':'Pink',
  'mauve':'Mauve',
  'blue':'Blue','cobalt':'Blue','royal blue':'Blue','navy':'Navy',
  'navy blue':'Navy','dark blue':'Navy','light blue':'Light Blue','sky blue':'Blue',
  'red':'Red','crimson':'Red','burgundy':'Burgundy','maroon':'Burgundy','wine':'Wine',
  'orange':'Orange','yellow':'Yellow','purple':'Purple','violet':'Purple',
  'lavender':'Lavender','multi':'Multi','multicolour':'Multi',
  'walnut/wood':'Walnut','white & wood':'White & Wood',
  'sherpa':'Sherpa White','velvet':'Velvet','boucle':'Boucle',
  'frameless':'Frameless','arched frame':'Arched',
  'black & white':'Black & White','white & black':'Black & White'
};
function getColourSuffix(colourValue) {
  if (!colourValue) return '';
  var key = colourValue.toLowerCase().trim();
  if (window.oikosFramelessMirror && key.indexOf('multi') !== -1) return 'Frameless';
  return _colourSuffixMap[key] || colourValue;
}
function updateProductTitle(colourValue, isColourOption, sizeValue, isSizeOption, mattressValue, isMattressOption, quantityValue, isQtyOption) {
  var titleEl = document.querySelector('.product-title');
  if (!titleEl) return;
  if (_baseProductTitle === null) {
    var cleanedBase = titleEl.getAttribute('data-base-title');
    if (cleanedBase) {
      _baseProductTitle = cleanedBase;
    } else {
      // Strip any existing (Set of N) from the initial title before storing as base
      _baseProductTitle = titleEl.textContent.trim().replace(/\s*\(Set of \d+\)\s*$/i, '').trim();
      titleEl.setAttribute('data-base-title', _baseProductTitle);
    }
  }
  if (isColourOption && colourValue) { _selectedColour = colourValue; }
  if (isSizeOption && sizeValue)     { _selectedSize   = sizeValue; }
  if (isMattressOption && mattressValue) { _selectedMattress = mattressValue; }
  if (isQtyOption) {
    // Set quantity label: null for Single/no-multiplier, "Set of N" for multi-unit
    var qLabel = quantityValue ? String(quantityValue).trim() : '';
    var isSingle = /^single$/i.test(qLabel) || qLabel === '' || qLabel === '1';
    _selectedQuantity = isSingle ? null : qLabel;
  }
  buildPageTitle();
}

var _oikosVariantContentPromise = null;
var _oikosVariantContentBySku = null;
var _oikosBaseDescriptionHtml = null;
var _oikosDocumentTitleBase = null;

function oikosEscapeRegExp(value) {
  return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function oikosVariantOptionTitlePart(optionName, optionValue) {
  var value = String(optionValue || '').trim();
  if (!value || /^default title$/i.test(value)) return '';

  if (/colou?r/i.test(String(optionName || ''))) {
    value = getColourSuffix(value);
  }

  if (/^(yes|no)$/i.test(value) && optionName) {
    return (/^yes$/i.test(value) ? 'With ' : 'Without ') + optionName;
  }

  return value;
}

function oikosVariantDisplayTitle(variant) {
  var titleEl = document.querySelector('.product-title');
  if (!titleEl || !variant) return '';

  var base = titleEl.getAttribute('data-base-title') || titleEl.textContent.trim();
  var optionNames = window.__oikosProductOptionNames || [];
  var optionValues = variant.options || [];
  var parts = optionValues.map(function(value, index) {
    return oikosVariantOptionTitlePart(optionNames[index], value);
  }).filter(Boolean);

  // Remove option values already present at the end so the suffix is consistent.
  parts.slice().reverse().forEach(function(part) {
    var rawPart = part.replace(/^(?:With|Without)\s+/i, '');
    var terminalPart = new RegExp('\\s*(?:[-\\u2013\\u2014]\\s*)?' + oikosEscapeRegExp(part) + '$', 'i');
    if (terminalPart.test(base)) {
      base = base.replace(terminalPart, '').trim();
    } else {
      base = base.replace(new RegExp('\\s*(?:[-\\u2013\\u2014]\\s*)?' + oikosEscapeRegExp(rawPart) + '$', 'i'), '').trim();
    }
  });

  return parts.length ? base + ' - ' + parts.join(' - ') : base;
}

function oikosApplyVariantTitle(variant) {
  var titleEl = document.querySelector('.product-title');
  if (!titleEl || !variant) return;

  var title = oikosVariantDisplayTitle(variant);
  var visibleTitle = typeof displayListingText === 'function' ? displayListingText(title) : title;
  titleEl.textContent = visibleTitle;

  var stickyTitle = document.querySelector('.pdp-sticky-title');
  if (stickyTitle) stickyTitle.textContent = visibleTitle;

  if (_oikosDocumentTitleBase === null) _oikosDocumentTitleBase = document.title;
  if (_oikosDocumentTitleBase) {
    var separatorIndex = _oikosDocumentTitleBase.indexOf(' | ');
    var shopSuffix = separatorIndex >= 0 ? _oikosDocumentTitleBase.slice(separatorIndex) : '';
    document.title = visibleTitle + shopSuffix;
  }
}

function oikosLoadVariantContent() {
  if (_oikosVariantContentBySku) return Promise.resolve(_oikosVariantContentBySku);
  if (_oikosVariantContentPromise) return _oikosVariantContentPromise;

  var descriptionEl = document.getElementById('productDescription');
  var url = window.__oikosVariantContentUrl || (descriptionEl && descriptionEl.getAttribute('data-variant-content-url'));
  if (!url) return Promise.resolve({});

  _oikosVariantContentPromise = fetch(url, { credentials: 'same-origin' })
    .then(function(response) {
      if (!response.ok) throw new Error('Variant content request failed: ' + response.status);
      return response.json();
    })
    .then(function(data) {
      _oikosVariantContentBySku = data && data.bySku ? data.bySku : {};
      return _oikosVariantContentBySku;
    })
    .catch(function(error) {
      console.warn('Variant content could not be loaded.', error);
      return {};
    });

  return _oikosVariantContentPromise;
}

function oikosSelectedVariantForContent() {
  var variantSelect = document.getElementById('variantId');
  var variantId = variantSelect ? String(variantSelect.value) : '';
  var variants = window.__oikosVariants || (typeof productVariants !== 'undefined' ? productVariants : []);

  for (var i = 0; i < variants.length; i++) {
    if (String(variants[i].id) === variantId) return variants[i];
  }
  return variants.length ? variants[0] : null;
}

function oikosApplyVariantContent(variant) {
  variant = variant || oikosSelectedVariantForContent();
  if (!variant) return;

  oikosApplyVariantTitle(variant);

  var descriptionEl = document.getElementById('productDescription');
  if (!descriptionEl) return;
  if (_oikosBaseDescriptionHtml === null) _oikosBaseDescriptionHtml = descriptionEl.innerHTML;

  var requestedSku = String(variant.sku || '').trim();
  if (!requestedSku) {
    descriptionEl.innerHTML = _oikosBaseDescriptionHtml;
    descriptionEl.removeAttribute('data-active-sku');
    return;
  }

  oikosLoadVariantContent().then(function(contentBySku) {
    var currentVariant = oikosSelectedVariantForContent();
    if (!currentVariant || String(currentVariant.sku || '').trim() !== requestedSku) return;

    var html = contentBySku[requestedSku] || contentBySku[requestedSku.toUpperCase()];
    descriptionEl.innerHTML = html || _oikosBaseDescriptionHtml;
    descriptionEl.setAttribute('data-active-sku', requestedSku);
  });
}

function oikosInitVariantContent() {
  var variantSelect = document.getElementById('variantId');
  if (variantSelect) {
    variantSelect.addEventListener('change', function() {
      oikosApplyVariantContent(oikosSelectedVariantForContent());
    });
  }
  setTimeout(function() {
    oikosApplyVariantContent(oikosSelectedVariantForContent());
  }, 160);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', oikosInitVariantContent);
} else {
  oikosInitVariantContent();
}

function selectOption(el, optionIndex, value) {
  var parent = el.parentElement;
  var siblings = parent.querySelectorAll('.swatch-option, .button-option');
  siblings.forEach(function(s) {
    s.classList.remove('selected');
    s.setAttribute('aria-checked', 'false');
    var radio = s.querySelector('input[type="radio"]');
    if (radio) radio.checked = false;
  });
  el.classList.add('selected');
  el.setAttribute('aria-checked', 'true');
  var optionInput = el.querySelector('input[type="radio"]');
  if (optionInput) optionInput.checked = true;
  var valLabel = document.getElementById('optVal-' + (optionIndex + 1));
  // Use the button's rendered text (which already has the true item count e.g. "Set of 6")
  // rather than the raw Shopify option value (e.g. "Set of 3")
  var _displayText = el.textContent ? el.textContent.trim() : displayOptionValue(value);
  if (valLabel) { valLabel.textContent = _displayText || displayOptionValue(value); }
  if (typeof productVariants === 'undefined') return;
  var optLabel = document.getElementById('optLabel-' + (optionIndex + 1));
  var optLabelText = optLabel ? optLabel.textContent : '';
  var isColourOpt = /colour|color|variant/i.test(optLabelText);
  var isSizeOpt   = /\bsize\b|\bdimension\b/i.test(optLabelText);
  var isMattressOpt = /mattress/i.test(optLabelText);
  var isQtyOpt = /quantity|qty/i.test(optLabelText);
  updateProductTitle(
    isColourOpt ? value : null, isColourOpt,
    isSizeOpt   ? value : null, isSizeOpt,
    isMattressOpt ? value : null, isMattressOpt,
    isQtyOpt ? _displayText : null, isQtyOpt
  );
  if (typeof selectedOptions !== 'undefined') {
    selectedOptions[optionIndex] = value;
  }
  var matchedVariant = findMatchingVariant(selectedOptions);
  if (matchedVariant) {
    var variantInput = document.getElementById('variantId');
    if (variantInput) { variantInput.value = matchedVariant.id; }
    var priceEl   = document.getElementById('productPrice');
    var compareEl = document.getElementById('productCompare');
    var saveEl    = document.getElementById('productPriceSave');
    if (priceEl && matchedVariant.price) {
      var rawPrice = matchedVariant.price;
      var rawCompare = matchedVariant.compare_at_price || 0;
      var hasVariantSale = rawCompare && rawCompare > rawPrice;
      priceEl.textContent = formatMoney(rawPrice);
      if (compareEl) {
        compareEl.textContent = hasVariantSale ? formatMoney(rawCompare) : '';
        compareEl.style.display = hasVariantSale ? '' : 'none';
      }
      if (saveEl) {
        saveEl.textContent = hasVariantSale ? ('Save ' + formatMoney(rawCompare - rawPrice)) : '';
        saveEl.style.display = hasVariantSale ? '' : 'none';
      }
    }
    var addBtn  = document.getElementById('addToCartBtn');
    var buyBtn  = document.querySelector('.btn-buy-now');
    if (matchedVariant.available) {
      if (addBtn) { addBtn.textContent = 'Add to cart'; addBtn.disabled = false; }
      if (buyBtn) { buyBtn.disabled = false; buyBtn.removeAttribute('aria-disabled'); buyBtn.style.opacity = ''; }
    } else {
      if (addBtn) { addBtn.textContent = 'Sold out'; addBtn.disabled = true; }
      if (buyBtn) { buyBtn.disabled = true; buyBtn.setAttribute('aria-disabled', 'true'); buyBtn.style.opacity = '0.35'; }
    }
    oikosApplyHeroImageForVariant(matchedVariant, isColourOpt ? value : null);
    if (typeof oikosApplyVariantGallery === 'function') {
      oikosApplyVariantGallery(matchedVariant);
    }
    oikosApplyVariantDimensions(matchedVariant.sku);
    if (typeof updateSkuDisplay === 'function') {
      updateSkuDisplay(matchedVariant.sku || '');
    }
    if (typeof oikosRefreshPackageContent === 'function') {
      oikosRefreshPackageContent();
    }
    if (typeof oikosApplyVariantContent === 'function') {
      oikosApplyVariantContent(matchedVariant);
    }
  }
  updateVariantAvailability();
}
function findMatchingVariant(opts) {
  if (typeof productVariants === 'undefined') return null;
  for (var i = 0; i < productVariants.length; i++) {
    var v = productVariants[i];
    var match = opts.every(function(o, j) { return v.options[j] === o; });
    if (match) return v;
  }
  return null;
}
function updateVariantAvailability() {
  if (typeof productVariants === 'undefined' || typeof selectedOptions === 'undefined') return;
  var numOpts = selectedOptions.length;
  for (var optIdx = 0; optIdx < numOpts; optIdx++) {
    var container = document.querySelector('[data-option-index="' + optIdx + '"]');
    if (!container) continue;
    var labels = container.querySelectorAll('label.swatch-option, label.button-option');
    labels.forEach(function(label) {
      var input = label.querySelector('input');
      if (!input) return;
      var testValue = input.value;
      var testOpts = selectedOptions.slice();
      testOpts[optIdx] = testValue;
      var comboExists = productVariants.some(function(v) {
        return testOpts.every(function(o, j) { return v.options[j] === o; });
      });
      var comboAvailable = productVariants.some(function(v) {
        return v.available && testOpts.every(function(o, j) { return v.options[j] === o; });
      });
      if (!comboExists) {
        label.classList.add('unavailable');
        label.classList.remove('sold-out');
        label.setAttribute('aria-disabled', 'true');
      } else if (!comboAvailable) {
        label.classList.add('sold-out');
        label.classList.remove('unavailable');
        label.setAttribute('aria-disabled', 'false');
      } else {
        label.classList.remove('unavailable', 'sold-out');
        label.setAttribute('aria-disabled', 'false');
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    updateVariantAvailability();
    var optLabels = document.querySelectorAll('[id^="optLabel-"]');
    optLabels.forEach(function(lbl) {
      var idx = lbl.id.replace('optLabel-', '');
      var valEl = document.getElementById('optVal-' + idx);
      if (!valEl || !valEl.textContent.trim()) return;
      var val = valEl.textContent.trim();
      var isColour = /colour|color/i.test(lbl.textContent);
      var isSize   = /\bsize\b/i.test(lbl.textContent);
      var isMattress = /mattress/i.test(lbl.textContent);
      var isQty = /quantity|qty/i.test(lbl.textContent);
      if (isColour || isSize || isMattress || isQty) {
        if (typeof updateProductTitle === 'function') {
          // For quantity: get the rendered display text from the selected button
          var qtyDisplay = null;
          if (isQty) {
            var optIdx2 = parseInt(idx, 10) - 1;
            var selBtn = document.querySelector('.button-options[data-option-index="' + optIdx2 + '"] .button-option.selected');
            qtyDisplay = selBtn ? (selBtn.textContent || '').trim() : val;
            // Also update the optVal label to show the rendered display text
            if (qtyDisplay) valEl.textContent = qtyDisplay;
          }
          updateProductTitle(
            isColour ? val : null, isColour,
            isSize   ? val : null, isSize,
            isMattress ? val : null, isMattress,
            isQty ? qtyDisplay : null, isQty
          );
        }
      }
    });
  }, 80);
});
function formatMoney(cents) {
  cents = Number(cents);
  if (!isFinite(cents)) cents = 0; // guard: never render "$NaN" if a price is missing
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('.product-form');
  if (!form) return;
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var formData = new FormData(form);
    var btn = document.getElementById('addToCartBtn');
    if (btn) {
      btn.textContent = 'Adding...';
      btn.disabled = true;
    }
    fetch(themeRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity')) || 1
      })
    })
    .then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    })
    .then(function(data) {
      if (btn) {
        btn.textContent = 'Added!';
        setTimeout(function() { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2000);
      }
      refreshCart();
      setTimeout(function() { toggleCart(); }, 400);
    })
    .catch(function(err) {
      console.error('Add to cart error:', err);
      if (btn) {
        btn.textContent = err.message && err.message.length < 40 ? err.message : 'Unavailable';
        setTimeout(function() { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2500);
      }
    });
  });
});
function quickAdd(e, variantId) {
  e.preventDefault();
  e.stopPropagation();
  fetch(themeRoute('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) {
    return res.json().then(function(data) {
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      return data;
    });
  })
  .then(function() {
    refreshCart();
    setTimeout(function() { toggleCart(); }, 400);
  })
  .catch(function(err) { console.error('Quick add error:', err); });
}
function buyNow() {
  var buyBtn = document.querySelector('.btn-buy-now');
  if (buyBtn && buyBtn.disabled) return;
  var variantEl = document.getElementById('variantId');
  var qtyEl = document.getElementById('quantityInput');
  var variantId = variantEl ? parseInt(variantEl.value, 10) : 0;
  var quantity = qtyEl ? parseInt(qtyEl.value, 10) : 1;
  if (!variantId) {
    if (buyBtn) {
      var original = buyBtn.textContent;
      buyBtn.textContent = 'Please choose an option';
      setTimeout(function() { buyBtn.textContent = original; }, 2500);
    }
    return;
  }
  window.location.href = singleVariantCheckoutUrl(variantId, quantity, savedDiscountCode());
}
function updateCartItem(key, quantity) {
  fetch(themeRoute('cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    if (isCartPage()) {
      window.location.reload();
      return;
    }
    refreshCart();
  })
  .catch(function(err) { console.error('Cart update error:', err); });
}
function rebuildCartDrawer(cart) {
  var wrap    = document.getElementById('cartItemsWrap');
  var footEl  = document.querySelector('.cart-drawer-footer');
  if (!wrap) return;
  if (cart.item_count === 0) {
    wrap.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p>'
      + '<a href="' + themeRoute('collections/all') + '" class="btn-primary" onclick="closeAll()">Continue shopping</a></div>';
    if (footEl) footEl.style.display = 'none';
    return;
  }
  if (!footEl) {
    var cartDrawer = document.getElementById('cartDrawer');
    if (cartDrawer) {
      var newFoot = document.createElement('div');
      newFoot.className = 'cart-drawer-footer';
      var savedDiscount = '';
      try { savedDiscount = sessionStorage.getItem('oikos_discount') || ''; } catch(e) {}
      var checkoutHref = savedDiscount
        ? checkoutUrl(savedDiscount)
        : checkoutUrl();
      newFoot.innerHTML = [
        '<div class="cart-subtotal-row">',
        '  <span class="cart-subtotal-label">Subtotal</span>',
        '  <span class="cart-subtotal-amount" id="cartSubtotal">' + formatMoney(typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price) + '</span>',
        '</div>',
        '<div class="cart-subtotal-row cart-discount-row" id="cartDiscountRow" style="display:none;">',
        '  <span class="cart-subtotal-label">Discount <span id="cartDiscountCode"></span></span>',
        '  <span class="cart-subtotal-amount cart-discount-amount" id="cartDiscountAmount"></span>',
        '</div>',
        '<div class="cart-subtotal-row cart-total-row">',
        '  <span class="cart-subtotal-label">Total</span>',
        '  <span class="cart-subtotal-amount" id="cartTotal">' + formatMoney(cart.total_price) + '</span>',
        '</div>',
        '<div class="cart-tax-note">GST included &middot; Shipping calculated at checkout</div>',
        '<div class="promo-row">',
        '  <input class="promo-input" type="text" placeholder="Discount code or gift card" id="discountInput" aria-label="Discount code or gift card" onkeydown="if(event.key===\'Enter\'){event.preventDefault();applyDiscount();}"' + (savedDiscount ? ' value="' + escapeHtml(savedDiscount) + '"' : '') + '>',
        '  <button class="promo-apply" type="button" aria-label="Apply discount code" onclick="applyDiscount()">Apply</button>',
        '</div>',
        '<div class="promo-msg" id="discountMsg" role="status" aria-live="polite" style="display:none;"></div>',
        '<a href="' + checkoutHref + '" class="btn-checkout">Checkout &rarr;</a>',
        '<div class="pay-methods">',
        '  <span class="pay-method">VISA</span><span class="pay-method">MC</span>',
        '  <span class="pay-method">AMEX</span><span class="pay-method">APPLE PAY</span>',
        '  <span class="pay-method">ZIP</span>',
        '</div>',
        '<div class="cart-secure">',
        '  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">',
        '    <rect x="3" y="11" width="18" height="11" rx="2"/>',
        '    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
        '  </svg>',
        '  <span>Secure &amp; encrypted checkout</span>',
        '</div>',
      ].join('');
      cartDrawer.appendChild(newFoot);
      footEl = newFoot;
    }
  } else {
    footEl.style.display = '';
  }
  var html = '';
  cart.items.forEach(function(item, i) {
    var lineNum  = i + 1;
    var safeTitle  = escapeHtml(displayListingText(item.product_title || item.title || ''));
    var safeVariant = escapeHtml(displayListingText(item.variant_title || ''));
    var safeImg    = item.image ? encodeURI(item.image) : '';
    var safeUrl    = encodeURI(item.url || '#');
    var safeKey    = String(item.key || '').replace(/[\\'"<>]/g, '');
    var imgHtml  = item.image
      ? '<img class="cart-item-img" src="' + safeImg + '" alt="' + safeTitle + '" width="70" height="70">'
      : '<div class="cart-item-img"></div>';
    var varHtml  = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-item-variant">' + safeVariant + '</div>' : '';
    html += '<div class="cart-item" data-key="' + safeKey + '">'
      + '<a href="' + safeUrl + '">' + imgHtml + '</a>'
      + '<div class="cart-item-info">'
      + '<div class="cart-item-title">' + safeTitle + '</div>'
      + varHtml
      + '<div class="cart-item-bottom">'
      + '<div class="qty-control">'
      + '<button class="qty-btn" type="button" aria-label="Decrease quantity for ' + escapeHtml(item.product_title || item.title || 'item') + '" onclick="cartQtyChange(\'' + safeKey + '\',' + Math.max(0, item.quantity - 1) + ')">−</button>'
      + '<span class="qty-num" aria-live="polite">' + item.quantity + '</span>'
      + '<button class="qty-btn" type="button" aria-label="Increase quantity for ' + escapeHtml(item.product_title || item.title || 'item') + '" onclick="cartQtyChange(\'' + safeKey + '\',' + (item.quantity + 1) + ')">+</button>'
      + '</div>'
      + '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>'
      + '</div>'
      + '<button class="cart-item-remove" type="button" aria-label="Remove ' + escapeHtml(item.product_title || item.title || 'item') + ' from cart" onclick="cartQtyChange(\'' + safeKey + '\',0)">Remove</button>'
      + '</div></div>';
  });
  wrap.innerHTML = html;
  renderCartDiscount(cart);
  updateCartBadge(cart.item_count);
}
function refreshCart() {
  fetch(themeRoute('cart.js'), { headers: { 'Accept': 'application/json' } })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    updateCartBadge(cart.item_count);
    rebuildCartDrawer(cart);
  })
  .catch(function(err) { console.error('Cart refresh error:', err); });
}
function updateCartBadge(count) {
  count = (typeof count === 'number') ? count : 0;
  var badge = document.getElementById('cartBadge');
  var countEl = document.getElementById('cartCount');
  if (badge) {
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
  }
  if (countEl) {
    countEl.textContent = '(' + count + ' ' + (count === 1 ? 'item' : 'items') + ')';
  }
}
function cartQtyChange(key, quantity) {
  var itemEl = document.querySelector('.cart-item[data-key="' + key + '"]');
  if (itemEl) {
    var qtyEl = itemEl.querySelector('.qty-num');
    if (quantity <= 0) {
      itemEl.style.opacity = '0.4';
    } else if (qtyEl) {
      qtyEl.textContent = quantity;
      var priceEl = itemEl.querySelector('.cart-item-price');
    }
  }
  document.querySelectorAll('.qty-btn,.cart-item-remove').forEach(function(b) { b.disabled = true; });
  fetch(themeRoute('cart/change.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    if (cart && typeof cart.item_count === 'number') {
      if (isCartPage()) {
        window.location.reload();
        return;
      }
      updateCartBadge(cart.item_count);
      rebuildCartDrawer(cart);
    } else {
      refreshCart();
    }
  })
  .catch(function(err) {
    console.error('Cart change error:', err);
    refreshCart();
  });
}
function setDiscountMsg(text, kind) {
  var msg = document.getElementById('discountMsg');
  if (!msg) return;
  if (!text) { msg.style.display = 'none'; msg.textContent = ''; msg.className = 'promo-msg'; return; }
  msg.textContent = text;
  msg.className = 'promo-msg' + (kind === 'err' ? ' promo-msg-err' : ' promo-msg-ok');
  msg.style.display = 'block';
}
function renderCartDiscount(cart) {
  if (!cart || typeof cart.total_price !== 'number') return;
  var subEl   = document.getElementById('cartSubtotal');
  var row     = document.getElementById('cartDiscountRow');
  var codeEl  = document.getElementById('cartDiscountCode');
  var amtEl   = document.getElementById('cartDiscountAmount');
  var totalEl = document.getElementById('cartTotal');
  var subtotal = (typeof cart.items_subtotal_price === 'number') ? cart.items_subtotal_price : cart.total_price;
  var applied = (cart.discount_codes || []).filter(function(d) { return d && d.applicable; });
  var discount = Math.max(0, subtotal - cart.total_price);
  if (subEl) subEl.textContent = formatMoney(subtotal);
  if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
  if (row) {
    if (applied.length && discount > 0) {
      if (codeEl) codeEl.textContent = '(' + applied.map(function(d) { return d.code; }).join(', ') + ')';
      if (amtEl) amtEl.textContent = '\u2212' + formatMoney(discount);
      row.style.display = 'flex';
    } else {
      row.style.display = 'none';
    }
  }
}
function applyDiscount() {
  var codeEl = document.getElementById('discountInput');
  var btn = document.querySelector('.promo-apply');
  if (!codeEl || !codeEl.value.trim()) return;
  var code = codeEl.value.trim().toUpperCase();
  setDiscountMsg('', '');
  if (btn) { btn.disabled = true; btn.textContent = 'Applying\u2026'; }
  fetch(themeRoute('cart/update.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ discount: code })
  })
  .then(function(res) { return res.json(); })
  .then(function(cart) {
    if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
    var codes = (cart && cart.discount_codes) || [];
    var entry = null;
    for (var i = 0; i < codes.length; i++) {
      if (String(codes[i].code || '').toUpperCase() === code) { entry = codes[i]; break; }
    }
    if (entry && entry.applicable) {
      try { sessionStorage.setItem('oikos_discount', code); } catch(e) {}
      codeEl.value = '';
      setDiscountMsg('Code ' + code + ' applied', 'ok');
      rebuildCartDrawer(cart);
    } else if (entry) {
      setDiscountMsg("'" + code + "' isn't valid for this cart", 'err');
      fetch(themeRoute('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      }).then(function(r) { return r.json(); }).then(function(c) { rebuildCartDrawer(c); }).catch(function() {});
    } else {
      try { sessionStorage.setItem('oikos_discount', code); } catch(e) {}
      setDiscountMsg('Code saved \u2014 it will be applied at checkout', 'ok');
      var checkoutBtn = document.querySelector('.btn-checkout');
      if (checkoutBtn) checkoutBtn.href = checkoutUrl(code);
    }
  })
  .catch(function(err) {
    console.error('Discount apply error:', err);
    if (btn) { btn.disabled = false; btn.textContent = 'Apply'; }
    setDiscountMsg('Could not apply the code \u2014 please try again', 'err');
  });
}
document.addEventListener('DOMContentLoaded', function() {
  try {
    var saved = sessionStorage.getItem('oikos_discount');
    if (saved) {
      var checkoutBtn = document.querySelector('.btn-checkout');
      if (checkoutBtn) {
        checkoutBtn.href = checkoutUrl(saved);
      }
    }
  } catch(e) {}
});
var searchDebounceTimer = null;
var lastSearchQuery = '';
function openSearch() {
  var input = document.getElementById('headerSearchInput');
  if (input && input.value.trim().length > 1) {
    showSearchPanel();
  }
}
function clearSearch() {
  var input = document.getElementById('headerSearchInput');
  var clearBtn = document.getElementById('searchClearBtn');
  var panel = document.getElementById('searchResultsPanel');
  if (input) { input.value = ''; input.focus(); }
  if (clearBtn) { clearBtn.style.display = 'none'; }
  if (panel) { panel.style.display = 'none'; }
  lastSearchQuery = '';
}
function showSearchPanel() {
  var panel = document.getElementById('searchResultsPanel');
  if (panel) { panel.style.display = 'block'; }
}
function hideSearchPanel() {
  var panel = document.getElementById('searchResultsPanel');
  if (panel) { panel.style.display = 'none'; }
}
function submitSearch(e) {
  var input = document.getElementById('headerSearchInput');
  if (!input || !input.value.trim()) {
    e.preventDefault();
    return;
  }
  hideSearchPanel();
}
function handleSearchInput(value) {
  var clearBtn = document.getElementById('searchClearBtn');
  if (clearBtn) { clearBtn.style.display = value.length > 0 ? 'flex' : 'none'; }
  clearTimeout(searchDebounceTimer);
  if (value.trim().length < 2) {
    hideSearchPanel();
    return;
  }
  showSearchPanel();
  setSearchLoading(true);
  searchDebounceTimer = setTimeout(function() {
    if (value.trim() !== lastSearchQuery) {
      lastSearchQuery = value.trim();
      fetchSearchResults(value.trim());
    }
  }, 280);
}
function setSearchLoading(show) {
  var loading = document.getElementById('searchLoading');
  var grid = document.getElementById('searchResultsGrid');
  var empty = document.getElementById('searchResultsEmpty');
  var footer = document.getElementById('searchResultsFooter');
  if (loading) { loading.style.display = show ? 'flex' : 'none'; }
  if (grid) { grid.style.display = show ? 'none' : 'grid'; }
  if (empty) { empty.style.display = 'none'; }
  if (footer) { footer.style.display = 'none'; }
}
function normaliseQuery(q) {
  q = (q == null) ? '' : String(q); // guard: tolerate non-string input
  q = q.trim().toLowerCase().replace(/\s+/g,' ');
  var subs = [
    [/wardrobes?/g,'wardrobe'],
    [/chairs?/g,'chair'],
    [/tables?/g,'table'],
    [/sofas?/g,'sofa'],
    [/couches?/g,'couch'],
    [/beds?\b/g,'bed'],
    [/shelves|shelfs/g,'shelf'],
    [/ottomans?/g,'ottoman'],
    [/mirrors?/g,'mirror'],
    [/desks?\b/g,'desk'],
    [/drawers?/g,'drawer'],
    [/frames?/g,'frame'],
    [/units?\b/g,'unit'],
    [/cabinets?/g,'cabinet'],
    [/dining chairs?/g,'dining chair'],
    [/office chairs?/g,'office chair'],
    [/bed frames?/g,'bed frame'],
    [/tv units?/g,'tv unit'],
    [/bookshelves|bookshelf/g,'bookshelf'],
    [/bedside tables?/g,'bedside table'],
    [/night stands?|nightstands?/g,'bedside table'],
    [/dressing tables?/g,'dressing table'],
    [/entertainment units?/g,'entertainment unit'],
    [/side boards?|sideboards?/g,'sideboard'],
    [/coffee tables?/g,'coffee table'],
    [/bar stools?/g,'bar stool'],
    [/bar tables?/g,'bar table'],
  ];
  subs.forEach(function(pair){ q = q.replace(pair[0], pair[1]); });
  return q;
}
function fetchSearchResults(query) {
  var normalised = normaliseQuery(query);
  var url = themeRoute('search/suggest.json') + '?q=' + encodeURIComponent(normalised) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor,tag';
  fetch(url, { headers: { 'Accept': 'application/json' } })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      setSearchLoading(false);
      var products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (products.length < 2 && normalised !== query.trim().toLowerCase()) {
        var url2 = themeRoute('search/suggest.json') + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,vendor';
        return fetch(url2, { headers: { 'Accept': 'application/json' } })
          .then(function(r){ return r.json(); })
          .then(function(d){
            var p2 = (d.resources && d.resources.results && d.resources.results.products) || [];
            renderSearchResults(products.concat(p2).filter(function(p,i,a){ return a.findIndex(function(x){return x.id===p.id;})=== i; }), query);
          });
      }
      renderSearchResults(products, query);
    })
    .catch(function(err) {
      console.error('Search error:', err);
      setSearchLoading(false);
      showSearchEmpty(query);
    });
}
function normaliseSearchPrice(raw) {
  if (raw === null || typeof raw === 'undefined' || raw === '') return null;
  var str = String(raw).replace(/[^0-9.\-]/g, '').trim();
  var n = parseFloat(str);
  if (!isFinite(n)) return null;
  return n;
}
function formatSearchPrice(raw) {
  var n = normaliseSearchPrice(raw);
  if (n === null) return '';
  return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function oikosLevenshtein(a, b) {
  if (a === b) return 0;
  var al = a.length, bl = b.length;
  if (!al) return bl; if (!bl) return al;
  if (Math.abs(al - bl) > 2) return 99;
  var prev = [], cur = [], i, j;
  for (j = 0; j <= bl; j++) prev[j] = j;
  for (i = 1; i <= al; i++) {
    cur[0] = i;
    for (j = 1; j <= bl; j++) {
      cur[j] = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + (a.charAt(i-1) === b.charAt(j-1) ? 0 : 1));
    }
    var tmp = prev; prev = cur; cur = tmp;
  }
  return prev[bl];
}
function oikosTokenMatchesWord(token, word) {
  if (!token || !word) return false;
  if (word.indexOf(token) === 0) return true;
  var tol = token.length >= 6 ? 2 : (token.length >= 4 ? 1 : 0);
  if (tol === 0) return token === word;
  var d = oikosLevenshtein(token, word);
  if (d > tol) return false;
  return d < 2 || token.charAt(0) === word.charAt(0);
}
function oikosStrictSearchFilter(products, query) {
  if (!Array.isArray(products)) return []; // guard: only operate on an array of products
  var tokens = String(query || '').toLowerCase().split(/[^a-z0-9]+/).filter(function(t){ return t.length > 1; });
  if (!tokens.length || !products.length) return products;
  var scored = products.map(function(p) {
    var hay = ((p.title || '') + ' ' + (p.product_type || p.type || '')).toLowerCase().split(/[^a-z0-9]+/);
    var hits = 0;
    for (var i = 0; i < tokens.length; i++) {
      for (var w = 0; w < hay.length; w++) {
        if (oikosTokenMatchesWord(tokens[i], hay[w])) { hits++; break; }
      }
    }
    return { p: p, hits: hits };
  });
  var strict = scored.filter(function(s){ return s.hits === tokens.length; });
  if (strict.length) return strict.map(function(s){ return s.p; });
  var best = 0;
  scored.forEach(function(s){ if (s.hits > best) best = s.hits; });
  if (best === 0) return [];
  return scored.filter(function(s){ return s.hits === best; }).map(function(s){ return s.p; });
}
function renderSearchResults(products, query) {
  var grid = document.getElementById('searchResultsGrid');
  var empty = document.getElementById('searchResultsEmpty');
  var footer = document.getElementById('searchResultsFooter');
  var viewAll = document.getElementById('searchViewAll');
  if (!grid) return;
  products = oikosStrictSearchFilter(products, query);
  if (products.length === 0) {
    grid.style.display = 'none';
    showSearchEmpty(query);
    return;
  }
  grid.style.display = 'grid';
  grid.innerHTML = products.map(function(p) {
    var rawPrice = (p.price !== null && typeof p.price !== 'undefined' && p.price !== '') ? p.price : (p.variants && p.variants[0] ? p.variants[0].price : '');
    var rawCompare = (p.compare_at_price !== null && typeof p.compare_at_price !== 'undefined' && p.compare_at_price !== '') ? p.compare_at_price : (p.variants && p.variants[0] ? p.variants[0].compare_at_price : '');
    var price = formatSearchPrice(rawPrice);
    var priceNum = normaliseSearchPrice(rawPrice);
    var compareNum = normaliseSearchPrice(rawCompare);
    var comparePrice = (compareNum !== null && priceNum !== null && compareNum > priceNum) ? formatSearchPrice(rawCompare) : '';
    var safeTitle = escapeHtml(displayListingText(p.title || ''));
    var safeType = escapeHtml(p.product_type || p.vendor || '');
    var safeUrl = escapeHtml(p.url || '#');
    var imgHtml = p.image
      ? '<img class="search-result-img" src="' + escapeHtml(p.image) + '" alt="' + safeTitle + '" width="60" height="60" loading="lazy">'
      : '<div class="search-result-img-placeholder"></div>';
    var compareHtml = comparePrice ? '<span class="search-result-compare">' + comparePrice + '</span>' : '';
    var variants = Array.isArray(p.variants) ? p.variants : [];
    var chosenVariant = variants.find(function(v) { return v && v.id && v.available === true; })
      || variants.find(function(v) { return v && v.id; })
      || null;
    var variantId = chosenVariant ? parseInt(chosenVariant.id, 10) : 0;
    var explicitlyAvailable = (p.available === true) || (chosenVariant && chosenVariant.available === true);
    var actionHtml = (explicitlyAvailable && variantId)
      ? '<button class="search-result-add" onclick="searchQuickAdd(event, ' + variantId + ')">Add to cart</button>'
      : '<a class="search-result-add search-result-view" href="' + safeUrl + '" onclick="hideSearchPanel()">View product</a>';
    return '<div class="search-result-card">' +
      '<a class="search-result-link" href="' + safeUrl + '" onclick="hideSearchPanel()">' +
        imgHtml +
        '<div class="search-result-info">' +
          '<div class="search-result-type">' + safeType + '</div>' +
          '<div class="search-result-title">' + safeTitle + '</div>' +
          '<div>' +
            '<span class="search-result-price">' + price + '</span>' +
            compareHtml +
          '</div>' +
        '</div>' +
      '</a>' +
      '<div class="search-result-actions">' + actionHtml + '</div>' +
    '</div>';
  }).join('');
  if (viewAll) {
    viewAll.href = themeRoute('search') + '?type=product&q=' + encodeURIComponent(query);
  }
  if (footer) { footer.style.display = 'block'; }
}
function showSearchEmpty(query) {
  var empty = document.getElementById('searchResultsEmpty');
  var term = document.getElementById('searchEmptyTerm');
  var grid = document.getElementById('searchResultsGrid');
  if (empty) { empty.style.display = 'block'; }
  if (term) { term.textContent = query; }
  if (grid) { grid.style.display = 'none'; }
}
function searchQuickAdd(e, variantId) {
  e.preventDefault();
  e.stopPropagation();
  var btn = e.currentTarget;
  btn.textContent = 'Adding...';
  btn.disabled = true;
  fetch(themeRoute('cart/add.js'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(function(res) {
    return res.json().then(function(data) {
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      return data;
    });
  })
  .then(function() {
    btn.textContent = 'Added!';
    setTimeout(function() { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2000);
    refreshCart();
    setTimeout(function() { hideSearchPanel(); toggleCart(); }, 600);
  })
  .catch(function(err) {
    console.error('Search quick add error:', err);
    btn.textContent = 'Unavailable';
    setTimeout(function() { btn.textContent = 'Add to cart'; btn.disabled = false; }, 2000);
  });
}
function escapeHtml(str) {
  if (!str) return '';
  return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
}
document.addEventListener('click', function(e) {
  var wrap = document.getElementById('headerSearchWrap');
  if (wrap && !wrap.contains(e.target)) {
    hideSearchPanel();
  }
});
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') { hideSearchPanel(); }
});
function applyPriceFilter() {
  var minInput = document.querySelector('[name="filter.v.price.gte"]');
  var maxInput = document.querySelector('[name="filter.v.price.lte"]');
  if (!minInput || !maxInput) return;
  var url = new URL(window.location.href);
  var minVal = String(minInput.value || '').trim();
  var maxVal = String(maxInput.value || '').trim();
  if (minVal) url.searchParams.set('filter.v.price.gte', minVal);
  else url.searchParams.delete('filter.v.price.gte');
  if (maxVal) url.searchParams.set('filter.v.price.lte', maxVal);
  else url.searchParams.delete('filter.v.price.lte');
  url.searchParams.delete('page');
  clearTimeout(window._priceFilterTimer);
  window._priceFilterTimer = setTimeout(function() {
    window.location.href = url.toString();
  }, 800);
}
var activeDiscountMin = 0;
function clearAllFilters(clearUrl) {
  window._jsFilterState = { onSale: false, discount: false, colour: false, size: false };
  activeDiscountMin = 0;
  if (typeof window._clearJsColourFilter === 'function') window._clearJsColourFilter();
  if (typeof window._clearJsSizeFilter === 'function') window._clearJsSizeFilter();
  document.querySelectorAll('#productGrid .product-card').forEach(function(c) { c.style.display = ''; });
  window.location.href = clearUrl || window.location.pathname;
}
document.addEventListener('click', function(e) {
  if (!e.target.closest('.type-dropdown-wrap')) {
    document.querySelectorAll('.type-dropdown-panel').forEach(function(p) { p.style.display = 'none'; });
    document.querySelectorAll('.type-dropdown-trigger').forEach(function(t) { t.classList.remove('is-open'); });
  }
  var searchWrap = document.getElementById('headerSearchWrap');
  if (searchWrap && !searchWrap.contains(e.target)) { hideSearchPanel && hideSearchPanel(); }
});
function showMoreOptions(btn) {
  var body = btn.parentElement;
  var hidden = body.querySelectorAll('.hidden-option');
  hidden.forEach(function(el) { el.style.display = ''; el.classList.remove('hidden-option'); });
  btn.style.display = 'none';
}
function sortCollection(val) {
  if (val.startsWith('js-')) {
    return;
  }
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', val);
  url.searchParams.delete('page');
  window.location.href = url.toString();
}
function sortSearchResults(val) {
  if (val.startsWith('js-')) {
    return;
  }
  var url = new URL(window.location.href);
  if (val === 'relevance') {
    url.searchParams.delete('sort_by');
  } else {
    url.searchParams.set('sort_by', val);
  }
  window.location.href = url.toString();
}
function changePerPage(val) {
  var url = new URL(window.location.href);
  url.searchParams.set('per_page', val);
  url.searchParams.delete('page');   // reset to page 1
  window.location.href = url.toString();
}
(function() {
  var SWATCH_COLOURS = {
    'black':         '#1a1a1a',
    'white':         '#f0f0f0',
    'grey':          '#888888',
    'gray':          '#888888',
    'light_grey':    '#c8c8c8',
    'light_gray':    '#c8c8c8',
    'dark_grey':     '#444444',
    'dark_gray':     '#444444',
    'charcoal':      '#3a3a3a',
    'beige':         '#d4b896',
    'cream':         '#f0ead6',
    'natural':       '#c4a882',
    'brown':         '#8b5e3c',
    'walnut':        '#6b3f1e',
    'oak':           '#c68642',
    'grey_oak':      '#9b9b6b',
    'green':         '#4a7c59',
    'olive':         '#6b7c45',
    'sage':          '#87ab88',
    'blue':          '#4a6fa5',
    'navy':          '#1a2a4a',
    'light_blue':    '#87ceeb',
    'sky_blue':      '#87ceeb',
    'pink':          '#e8a0b4',
    'rose':          '#e0727a',
    'gold':          '#d4a843',
    'champagne':     '#d4b896',
    'silver':        '#a8a8a8',
    'red':           '#c0392b',
    'orange':        '#e67e22',
    'yellow':        '#f0c040',
    'purple':        '#7d3c98',
    'lavender':      '#b39ad4',
    'teal':          '#2e8b8b',
    'antique_brown': '#8b6040',
    'caramel':       '#c68040',
    'black_flannel':        '#1a1a1a',
    'blue_flannel':         '#4a6fa5',
    'navy_flannel':         '#1a2a4a',
    'cream_flannel':        '#f0ead6',
    'grey_flannel':         '#888888',
    'charcoal_flannel':     '#3a3a3a',
    'white_flannel':        '#f0f0f0',
    'pink_flannel':         '#e8a0b4',
    'charcoal_fleece':      '#3a3a3a',
    'black_fleece':         '#1a1a1a',
    'cream_fleece':         '#f0ead6',
    'grey_fleece':          '#888888',
    'blue_fleece':          '#4a6fa5',
    'navy_fleece':          '#1a2a4a',
    'multi_colour_fleece':  'linear-gradient(135deg,#e74c3c 0%,#f0c040 33%,#2ecc71 66%,#4a6fa5 100%)',
    'multi-colour_fleece':  'linear-gradient(135deg,#e74c3c 0%,#f0c040 33%,#2ecc71 66%,#4a6fa5 100%)',
    'burgundy_sherpa':      '#6b1a2a',
    'beige_sherpa':         '#d4b896',
    'cream_sherpa':         '#f0ead6',
    'grey_sherpa':          '#888888',
    'charcoal_sherpa':      '#3a3a3a',
    'black_sherpa':         '#1a1a1a',
    'navy_sherpa':          '#1a2a4a',
  };
  var styleEl = document.createElement('style');
  var css = ':root{';
  Object.keys(SWATCH_COLOURS).forEach(function(key) {
    css += '--swatch-' + key + ':' + SWATCH_COLOURS[key] + ';';
  });
  css += '}';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);
})();
var _cardColourSuffixMap = {
  'black':'Black','matte black':'Black','charcoal':'Charcoal','white':'White',
  'cream':'Cream','off white':'White','pearl':'White','boucle white':'White',
  'cloud white':'White','beige':'Beige','sand':'Beige','linen':'Linen',
  'taupe':'Taupe','stone':'Stone','champagne':'Champagne','ivory':'Ivory',
  'oatmeal':'Oatmeal','grey':'Grey','gray':'Grey','silver':'Silver',
  'light grey':'Light Grey','dark grey':'Dark Grey','slate':'Slate',
  'natural':'Natural','rattan':'Rattan','timber':'Timber','wood':'Wood',
  'pine':'Pine','oak':'Oak','walnut':'Walnut','brown':'Brown','mocha':'Brown',
  'coffee':'Brown','dark brown':'Dark Brown','chocolate':'Brown',
  'copper':'Copper','bronze':'Bronze','rust':'Rust','terracotta':'Terracotta',
  'gold':'Gold','brass':'Brass','green':'Green','emerald':'Green','sage':'Sage',
  'dark green':'Dark Green','olive':'Olive','teal':'Teal','pink':'Pink',
  'blush':'Pink','rose':'Rose','dusty pink':'Pink','mauve':'Mauve',
  'blue':'Blue','cobalt':'Blue','navy':'Navy','navy blue':'Navy',
  'dark blue':'Navy','light blue':'Light Blue','red':'Red','crimson':'Red',
  'burgundy':'Burgundy','maroon':'Burgundy','wine':'Wine','orange':'Orange',
  'yellow':'Yellow','purple':'Purple','violet':'Purple','lavender':'Lavender',
  'multi':'Multi','walnut/wood':'Walnut','white & wood':'White & Wood',
  'sherpa':'Sherpa White','velvet':'Velvet','boucle':'Boucle',
  'frameless':'Frameless','arched frame':'Arched'
};
function getCardColourSuffix(colourName, card) {
  if (!colourName) return colourName;
  var key = colourName.toLowerCase().trim();
  if (card && card.getAttribute('data-frameless-mirror') === 'true' && key.indexOf('multi') !== -1) return 'Frameless';
  return _cardColourSuffixMap[key] || colourName;
}
function updateCardTitle(card, colourName) {
  var titleEl = card.querySelector('.product-card-title');
  if (!titleEl) return;
  if (!titleEl.hasAttribute('data-base-title')) {
    var baseFromDom = titleEl.textContent.trim();
    titleEl.setAttribute('data-base-title', baseFromDom);
  }
  var base = titleEl.getAttribute('data-base-title') || '';
  if (colourName) {
    var suffix = getCardColourSuffix(colourName, card);
    var normBase = base.toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    var normSuffix = String(suffix || '').toLowerCase().replace(/[-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    titleEl.textContent = (normSuffix && normBase.indexOf(normSuffix) === -1) ? (base + ' - ' + suffix) : base;
  } else {
    titleEl.textContent = base;
  }
}
function updateProductCardSaleDisplay(card, priceCents, compareCents) {
  if (!card || !priceCents) return;
  var priceEl = card.querySelector('.product-card-price');
  var pricesWrap = card.querySelector('.product-card-prices');
  if (!pricesWrap) return;
  if (!priceEl) {
    priceEl = document.createElement('span');
    priceEl.className = 'product-card-price';
    pricesWrap.appendChild(priceEl);
  }
  priceEl.textContent = formatMoney(priceCents);
  var hasSale = compareCents && compareCents > priceCents;
  var rrpEl = card.querySelector('.product-card-rrp');
  var badgeEl = card.querySelector('.product-card-coupon');
  var badgeTop = card.querySelector('.product-badge.badge-sale');
  if (hasSale) {
    var pct = Math.round((compareCents - priceCents) * 100 / compareCents);
    if (!rrpEl) {
      rrpEl = document.createElement('span');
      rrpEl.className = 'product-card-rrp';
      pricesWrap.appendChild(rrpEl);
    }
    rrpEl.innerHTML = 'RRP <s>' + formatMoney(compareCents) + '</s>';
    if (!badgeEl) {
      badgeEl = document.createElement('span');
      badgeEl.className = 'product-card-coupon';
      pricesWrap.appendChild(badgeEl);
    }
    badgeEl.textContent = pct + '% off';
    if (badgeTop) {
      badgeTop.textContent = pct + '% off';
      badgeTop.style.display = '';
    }
    card.setAttribute('data-discount', String(pct));
    card.setAttribute('data-savings', String(compareCents - priceCents));
  } else {
    if (rrpEl) rrpEl.remove();
    if (badgeEl) badgeEl.remove();
    if (badgeTop) badgeTop.style.display = 'none';
    card.setAttribute('data-discount', '0');
    card.setAttribute('data-savings', '0');
  }
  card.setAttribute('data-price', String(priceCents));
}
function cardSwatchClick(event, swatchBtn) {
  event.preventDefault();
  event.stopPropagation();
  var card = swatchBtn.closest('.product-card');
  if (!card) return;
  var allSwatches = card.querySelectorAll('.product-card-swatch, .product-card-size');
  allSwatches.forEach(function(s) { s.classList.remove('is-active'); });
  swatchBtn.classList.add('is-active');
  var colourName = swatchBtn.getAttribute('title') || swatchBtn.getAttribute('aria-label') || '';
  updateCardTitle(card, colourName);
  var swPrice = parseInt(swatchBtn.getAttribute('data-price') || '0', 10);
  var swCompare = parseInt(swatchBtn.getAttribute('data-compare') || '0', 10);
  if (swPrice > 0) {
    updateProductCardSaleDisplay(card, swPrice, swCompare);
  }
  var newSrc = swatchBtn.getAttribute('data-img');
  var primaryImg = card.querySelector('.product-card-img-primary');
  if (newSrc && primaryImg) {
    primaryImg.style.transition = 'opacity 0.2s';
    primaryImg.style.opacity = '0';
    primaryImg.onload = function() {
      primaryImg.style.opacity = '1';
      primaryImg.onload = null;
    };
    var fallbackSrc = swatchBtn.getAttribute('data-fallback') || '';
    if (fallbackSrc && fallbackSrc !== newSrc) {
      primaryImg.onerror = function() {
        primaryImg.onerror = null;
        setResponsiveImage(primaryImg, fallbackSrc, primaryImg.alt);
        primaryImg.style.opacity = '1';
      };
    } else {
      primaryImg.onerror = null;
    }
    setResponsiveImage(primaryImg, newSrc, primaryImg.alt);
    if (primaryImg.complete) {
      setTimeout(function() { primaryImg.style.opacity = '1'; }, 30);
    }
  }
  var variantId = swatchBtn.getAttribute('data-variant');
  var explicitUrl = swatchBtn.getAttribute('data-url');
  var links = card.querySelectorAll('.product-card-image-link, .product-card-info-link, .product-card-link, .product-card-inner');
  links.forEach(function(link) {
    if (explicitUrl) {
      link.href = explicitUrl;
    } else if (variantId) {
      var href = link.getAttribute('href') || '';
      try {
        var u = new URL(href, window.location.origin);
        u.searchParams.set('variant', variantId);
        link.href = u.pathname + u.search + u.hash;
      } catch(e) {}
    }
  });
  var quick = card.querySelector('.product-quick-add');
  if (quick && variantId) {
    quick.setAttribute('onclick', 'quickAdd(event, ' + variantId + ')');
  }
}
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.product-card').forEach(function(card) {
    if (card.getAttribute('data-preserve-initial-variant') === 'true') return;
    var firstActive = card.querySelector('.product-card-swatch.is-active');
    if (firstActive) {
      cardSwatchClick({ preventDefault: function(){}, stopPropagation: function(){} }, firstActive);
    }
  });
  if (typeof productVariants !== 'undefined' && typeof selectedOptions !== 'undefined' && typeof findMatchingVariant === 'function') {
    var currentVariant = findMatchingVariant(selectedOptions);
    if (currentVariant) {
      oikosApplyHeroImageForVariant(currentVariant, null);
      if (typeof updateProductTitle === 'function') {
        (currentVariant.options || []).forEach(function(optVal, i) {
          var lbl = document.getElementById('optLabel-' + (i + 1));
          var labelText = lbl ? lbl.textContent : '';
          var isColour = /colour|color|variant/i.test(labelText);
          var isSize = /\bsize\b|\bdimension\b/i.test(labelText);
          var isMattress = /mattress/i.test(labelText);
          if (isColour || isSize || isMattress) {
            updateProductTitle(
              isColour ? optVal : null, isColour,
              isSize ? optVal : null, isSize,
              isMattress ? optVal : null, isMattress
            );
          }
        });
      }
      if (typeof oikosApplyVariantDimensions === 'function') oikosApplyVariantDimensions(currentVariant.sku || '');
      if (typeof updateSkuDisplay === 'function') updateSkuDisplay(currentVariant.sku || '');
    }
  }
});
(function syncJdgmCardStars() {
  function svgStar(type, id, frac) {
    var pts = '12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2';
    if (type === 'full') {
      return '<svg class="lstar lstar--full" viewBox="0 0 24 24"><polygon points="' + pts + '"/></svg>';
    }
    if (type === 'empty') {
      return '<svg class="lstar lstar--empty" viewBox="0 0 24 24"><polygon points="' + pts + '"/></svg>';
    }
    var cw = Math.round(frac * 24);
    var uid = 'cp_' + id + '_' + cw;
    return '<svg class="lstar lstar--partial" viewBox="0 0 24 24">'
      + '<defs><clipPath id="' + uid + '"><rect x="0" y="0" width="' + cw + '" height="24"/></clipPath></defs>'
      + '<polygon class="partial-bg" points="' + pts + '"/>'
      + '<polygon class="partial-fill" clip-path="url(#' + uid + ')" points="' + pts + '"/>'
      + '</svg>';
  }
  function buildStarHTML(avg, cnt, cardId) {
    var f = Math.floor(avg), fr = avg - f, s = '';
    for (var i = 1; i <= 5; i++) {
      if (i <= f) { s += svgStar('full'); }
      else if (i === f + 1 && fr > 0.05) { s += svgStar('partial', cardId + '_' + i, fr); }
      else { s += svgStar('empty'); }
    }
    return '<span class="card-stars-svg">' + s + '</span>'
      + (cnt > 0 ? '<span class="card-star-count">' + cnt + '</span>' : '');
  }
  function applyStarsToCard(card, avg, cnt) {
    if (avg < 1 || avg > 5) return;
    var starsWrap = card.querySelector('.product-card-stars');
    if (!starsWrap) return;
    if (starsWrap.querySelector('.card-stars-svg')) return;
    starsWrap.innerHTML = buildStarHTML(avg, cnt, card.getAttribute('data-product-id') || '');
    card.setAttribute('data-rating', avg);
    card.setAttribute('data-rating-count', cnt);
  }
  function tryPreloadBadge(card) {
    var pid = parseInt(card.getAttribute('data-product-id'), 10);
    if (pid && window.jdgm && jdgm.data && jdgm.data.previewBadge) {
      var pb = jdgm.data.previewBadge[pid];
      if (pb) {
        var avg = parseFloat(pb.average_rating || pb.averageRating || pb.avg_rating || 0);
        var cnt = parseInt(pb.number_of_reviews || pb.numberOfReviews || pb.num_reviews || 0, 10);
        if (avg >= 1) { applyStarsToCard(card, avg, cnt); return true; }
      }
    }
    return false;
  }
  function processAllCards() {
    document.querySelectorAll('.product-card').forEach(function(card) {
      if (!tryPreloadBadge(card)) {
        var badge = card.querySelector('.product-card-stars .jdgm-preview-badge');
        if (badge && !badge._jdgmObserved && window.MutationObserver) {
          badge._jdgmObserved = true;
          var ra = parseFloat(badge.getAttribute('data-average-rating') || '0');
          var rc = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
          if (ra >= 1) { applyStarsToCard(card, ra, rc); return; }
          var obs = new MutationObserver(function(mutations) {
            mutations.forEach(function(m) {
              if (m.attributeName === 'data-average-rating') {
                var avg = parseFloat(badge.getAttribute('data-average-rating') || '0');
                var cnt = parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10);
                if (avg >= 1) {
                  applyStarsToCard(card, avg, cnt);
                  obs.disconnect();
                }
              }
            });
          });
          obs.observe(badge, { attributes: true });
        }
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    processAllCards();
    setTimeout(processAllCards, 800);
    setTimeout(processAllCards, 2500);
  });
  if (document.readyState !== 'loading') {
    processAllCards();
    setTimeout(processAllCards, 800);
  }
})();
(function() {
  var swipeStartX = 0, swipeStartY = 0, swiping = false;
  document.addEventListener('touchstart', function(e) {
    var imgWrap = e.target.closest && e.target.closest('.product-images, .product-main-image, #mainImg');
    if (!imgWrap) return;
    swipeStartX = e.changedTouches[0].clientX;
    swipeStartY = e.changedTouches[0].clientY;
    swiping = true;
  }, { passive: true });
  document.addEventListener('touchend', function(e) {
    if (!swiping) return;
    swiping = false;
    var dx = e.changedTouches[0].clientX - swipeStartX;
    var dy = e.changedTouches[0].clientY - swipeStartY;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
    if (typeof productImages === 'undefined' || !productImages.length) return;
    var mainImg = document.getElementById('mainImg');
    if (!mainImg) return;
    var curSrc = mainImg.src;
    var curIdx = productImages.findIndex(function(img) { return curSrc.includes(img.src.split('?')[0].split('/').pop().split('_')[0]); });
    if (curIdx < 0) curIdx = 0;
    var nextIdx = dx < 0
      ? Math.min(curIdx + 1, productImages.length - 1)
      : Math.max(curIdx - 1, 0);
    if (typeof switchImageByIndex === 'function') switchImageByIndex(nextIdx);
  }, { passive: true });
})();
window.addEventListener('scroll', function() {
  var btn = document.getElementById('scrollTopBtn');
  if (!btn) return;
  btn.style.opacity = window.scrollY > 400 ? '1' : '0';
  btn.style.pointerEvents = window.scrollY > 400 ? 'auto' : 'none';
}, { passive: true });
function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
(function() {
  function hasNativeFilterParams() {
    try {
      var params = new URLSearchParams(window.location.search);
      var active = false;
      params.forEach(function(value, key) {
        if (key.indexOf('filter.') === 0 && String(value).trim() !== '') active = true;
      });
      return active;
    } catch (e) {
      return false;
    }
  }
  function getVisibleProductCount() {
    var grid = document.getElementById('productGrid');
    if (!grid) return null;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
    if (!cards.length) return 0;
    return cards.filter(function(card) {
      return card.offsetParent !== null && window.getComputedStyle(card).display !== 'none' && card.style.display !== 'none';
    }).length;
  }
  function hasActiveJsFilters() {
    var state = window._jsFilterState || {};
    return !!(state.onSale || state.discount || state.colour || state.size);
  }
  function setProductCountText(el, count) {
    var role = el.getAttribute('data-product-count-role') || (el.classList.contains('coll-hero-count-pill') ? 'hero' : 'controls');
    var noun;
    if (role === 'hero') {
      noun = count === 1 ? 'item' : 'items';
      el.textContent = count + ' ' + noun;
    } else {
      noun = count === 1 ? 'product' : 'products';
      var suffix = '';
      var current = (el.textContent || '').toLowerCase();
      if (current.indexOf('on sale') !== -1) suffix = ' on sale';
      else if (current.indexOf('found') !== -1) suffix = ' found';
      el.textContent = count + ' ' + noun + suffix;
    }
  }
  window._updateThemeProductCounts = function(forceVisibleCount) {
    var countEls = Array.prototype.slice.call(document.querySelectorAll('[data-product-count-role], #collectionCount, #collectionHeroCount, .coll-hero-count-pill'));
    if (!countEls.length) return;
    var visibleCount = getVisibleProductCount();
    var shouldUseVisible = !!forceVisibleCount || hasActiveJsFilters() || hasNativeFilterParams();
    countEls.forEach(function(el) {
      var fallback = parseInt(el.getAttribute('data-liquid-count') || '0', 10);
      var count = (shouldUseVisible && visibleCount !== null) ? visibleCount : fallback;
      if (!count && visibleCount !== null && el.getAttribute('data-liquid-count') === '0') count = visibleCount;
      setProductCountText(el, count || 0);
    });
  };
  window._updateJsFilterUI = function() {
    var grid = document.getElementById('productGrid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
    var visibleCount = getVisibleProductCount();
    var anyActive = hasActiveJsFilters();
    window._updateThemeProductCounts(anyActive);
    var noRes = document.getElementById('noJsFilterResults');
    var noPag = document.getElementById('noJsFilterPagination');
    var realPag = document.getElementById('collectionPagination');
    var isEmpty = anyActive && visibleCount === 0;
    if (noRes) {
      noRes.hidden = !isEmpty;
      noRes.setAttribute('aria-hidden', isEmpty ? 'false' : 'true');
      noRes.style.display = isEmpty ? 'flex' : 'none';
      var titleEl = noRes.querySelector('[data-no-js-title]');
      var subEl = noRes.querySelector('[data-no-js-sub]');
      if (isEmpty) {
        if (titleEl) titleEl.textContent = 'No results found';
        if (subEl) {
          subEl.innerHTML = '';
          subEl.appendChild(document.createTextNode('No products match the active filters. Try adjusting your selection or '));
          var resetUrl = noRes.getAttribute('data-reset-url') || window.location.pathname;
          var link = document.createElement('a');
          link.className = 'no-js-filter-reset';
          link.href = resetUrl;
          link.textContent = 'clearing all filters';
          subEl.appendChild(link);
          subEl.appendChild(document.createTextNode('.'));
        }
      } else {
        if (titleEl) titleEl.textContent = '';
        if (subEl) subEl.textContent = '';
      }
    }
    if (noPag) {
      noPag.hidden = !isEmpty;
      noPag.setAttribute('aria-hidden', isEmpty ? 'false' : 'true');
      noPag.textContent = isEmpty ? (noPag.getAttribute('data-page-label') || 'Page 1 of 1') : '';
      noPag.style.display = isEmpty ? 'block' : 'none';
    }
    if (realPag) realPag.style.display = anyActive ? 'none' : (realPag.getAttribute('data-has-pages') ? '' : 'none');
  };
  document.addEventListener('DOMContentLoaded', function() {
    window._updateThemeProductCounts(false);
  });
})();

/* ===== Search results page: spelling-tolerant relevance filter =====
   The full /search results page uses Shopify's default engine, which also
   matches product descriptions and collection descriptions. That is why a
   search for "sofa" could surface bed frames / bedside tables whose
   descriptions merely mention the word. Shopify does not allow the searched
   fields to be restricted on the results page (only on the predictive
   suggest.json endpoint the header dropdown uses), so we re-filter the
   rendered results client-side using the SAME matching engine as the
   dropdown (oikosTokenMatchesWord / oikosLevenshtein). This keeps both search
   surfaces consistent and tolerant of spelling mistakes.

   Match signal = product title + product type (mirrors oikosStrictSearchFilter).
   Any product whose title/type does not genuinely match every search word is
   removed. If nothing matches every word we keep the best partial matches, so
   multi-word queries still return their most relevant items. */
(function() {
  function onSearchResultsPage() {
    var path = String(location.pathname || '').replace(/\/+$/, '');
    return /(^|\/)search$/.test(path) && !!document.getElementById('productGrid');
  }
  function getSearchQuery() {
    try {
      var params = new URLSearchParams(location.search);
      return (params.get('q') || '').trim();
    } catch (e) {
      var m = String(location.search || '').match(/[?&]q=([^&]*)/);
      return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')).trim() : '';
    }
  }
  function tokenMatches(token, word) {
    if (typeof oikosTokenMatchesWord === 'function') return oikosTokenMatchesWord(token, word);
    return !!word && word.indexOf(token) === 0; // safe fallback: prefix match
  }
  function buildFilteredEmpty(query) {
    var area = document.querySelector('.product-area');
    if (!area || document.getElementById('oikosSearchNoMatch')) return;
    var root = (typeof themeRoute === 'function') ? themeRoute('collections/all') : '/collections/all';
    var safe = String(query == null ? '' : query).replace(/[&<>"']/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
    var wrap = document.createElement('div');
    wrap.id = 'oikosSearchNoMatch';
    wrap.className = 'search-empty';
    wrap.innerHTML =
      '<svg class="search-empty-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path></svg>' +
      '<p class="search-empty-title">No close matches for "' + safe + '"</p>' +
      '<p class="search-empty-sub">We only show products that actually match your search. Check your spelling, try a more general term, or browse all products.</p>' +
      '<a href="' + root + '" class="btn-primary">Browse all products</a>';
    area.appendChild(wrap);
  }
  function filterSearchResultsPage() {
    if (!onSearchResultsPage()) return;
    var rawQuery = getSearchQuery();
    if (!rawQuery) return;
    var tokens = rawQuery.toLowerCase().split(/[^a-z0-9]+/).filter(function(t) { return t.length > 1; });
    if (!tokens.length) return;

    var grid = document.getElementById('productGrid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
    if (!cards.length) return;

    var scored = cards.map(function(card) {
      var title = card.getAttribute('data-title') || '';
      var type = card.getAttribute('data-product-type') || '';
      var hay = (title + ' ' + type).toLowerCase().split(/[^a-z0-9]+/);
      var hits = 0;
      for (var i = 0; i < tokens.length; i++) {
        for (var w = 0; w < hay.length; w++) {
          if (tokenMatches(tokens[i], hay[w])) { hits++; break; }
        }
      }
      return { card: card, hits: hits };
    });

    var required = tokens.length;
    var keep = scored.filter(function(s) { return s.hits === required; });
    if (!keep.length) {
      var best = 0;
      scored.forEach(function(s) { if (s.hits > best) best = s.hits; });
      if (best > 0) keep = scored.filter(function(s) { return s.hits === best; });
    }
    var keepCards = keep.map(function(s) { return s.card; });
    if (keepCards.length === cards.length) return; // everything is already relevant

    scored.forEach(function(s) {
      if (keepCards.indexOf(s.card) === -1 && s.card.parentNode) {
        s.card.parentNode.removeChild(s.card);
      }
    });

    var remaining = keepCards.length;
    var countEl = document.getElementById('collectionCount');
    if (countEl) countEl.setAttribute('data-liquid-count', String(remaining));
    if (typeof window._updateThemeProductCounts === 'function') {
      window._updateThemeProductCounts(true);
    }

    if (remaining === 0) {
      var pag = document.getElementById('collectionPagination');
      if (pag) pag.style.display = 'none';
      buildFilteredEmpty(rawQuery);
    }
  }
  document.addEventListener('DOMContentLoaded', filterSearchResultsPage);
})();

function toggleMobileFilters(open) {
  var body = document.body;
  var scrim = document.getElementById('mobileFilterScrim');
  if (open) {
    body.classList.add('filters-open');
    if (scrim) scrim.classList.add('visible');
    var panel = document.querySelector('.filter-panel');
    if (panel) panel.scrollTop = 0;
  } else {
    body.classList.remove('filters-open');
    if (scrim) scrim.classList.remove('visible');
  }
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape' && document.body.classList.contains('filters-open')) toggleMobileFilters(false);
});

/* ===== Quick View ===== */
(function(){
  var qvState = { product: null, variant: null };

  function overlay(){ return document.getElementById('quickViewOverlay'); }
  function bodyEl(){ return document.getElementById('quickViewBody'); }

  function qvMoney(cents){
    if (typeof formatMoney === 'function') return formatMoney(cents);
    return '$' + (parseInt(cents||0,10)/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function qvEsc(s){ return String(s==null?'':s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }

  window.openQuickView = function(e, handle){
    if (e){ e.preventDefault(); e.stopPropagation(); }
    var ov = overlay(); if (!ov || !handle) return;
    /* Inherit the automatic-discount decision from the originating product card
       (set server-side via data-ad / data-ad-pct), so Quick View matches the card. */
    var _qvCard = (e && e.target && e.target.closest) ? e.target.closest('.product-card') : null;
    qvState.ad = {
      applies: !!(_qvCard && _qvCard.getAttribute('data-ad') === '1'),
      pct: _qvCard ? (parseInt(_qvCard.getAttribute('data-ad-pct') || '0', 10) || 0) : 0
    };
    ov.classList.add('is-open');
    ov.setAttribute('aria-hidden','false');
    document.body.classList.add('quickview-open');
    var body = bodyEl();
    if (body){ body.innerHTML = '<div class="quickview-loading"><div class="quickview-spinner"></div></div>'; }
    fetch(themeRoute('products/' + encodeURIComponent(handle) + '.js'), { headers: { 'Accept':'application/json' } })
      .then(function(r){ if(!r.ok) throw new Error('load failed'); return r.json(); })
      .then(function(p){ qvState.product = p; qvState.variant = pickVariant(p); renderQuickView(p); })
      .catch(function(){
        if (body){ body.innerHTML = '<div class="quickview-error">Sorry, this product couldn\u2019t be loaded. <a href="'
          + themeRoute('products/' + encodeURIComponent(handle)) + '">View full page</a></div>'; }
      });
  };

  window.closeQuickView = function(){
    var ov = overlay(); if (!ov) return;
    ov.classList.remove('is-open');
    ov.setAttribute('aria-hidden','true');
    document.body.classList.remove('quickview-open');
  };

  function pickVariant(p){
    var vs = p.variants || [];
    for (var i=0;i<vs.length;i++){ if (vs[i].available) return vs[i]; }
    return vs[0] || null;
  }

  function variantFromSelections(p, sel){
    var vs = p.variants || [];
    for (var i=0;i<vs.length;i++){
      var v = vs[i], ok = true;
      for (var j=0;j<sel.length;j++){ if (sel[j] != null && v.options[j] !== sel[j]) { ok = false; break; } }
      if (ok) return v;
    }
    return null;
  }

  function renderQuickView(p){
    var body = bodyEl(); if (!body) return;
    var v = qvState.variant || pickVariant(p);
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || (p.images && p.images[0]) || '';
    var price = v ? v.price : p.price;
    var compare = v ? v.compare_at_price : p.compare_at_price;
    var _qad = qvState.ad || {};
    if (_qad.applies && _qad.pct > 0 && price > 0){
      var _qwas = (compare && compare > price) ? compare : price;
      price = Math.round(price * (100 - _qad.pct) / 100);
      compare = _qwas;
    }
    var hasSale = compare && compare > price;

    // Build option selectors (skip a lone "Default Title" option)
    var optionsHtml = '';
    var meaningful = (p.options || []).length && !(p.options.length === 1 && /default/i.test(p.options[0]));
    if (meaningful){
      p.options.forEach(function(optName, idx){
        var values = [];
        (p.variants||[]).forEach(function(vr){ var val = vr.options[idx]; if (values.indexOf(val)===-1) values.push(val); });
        var sel = qvState.variant ? qvState.variant.options[idx] : null;
        optionsHtml += '<div class="quickview-option"><span class="quickview-option-label">' + qvEsc(optName) + '</span><div class="quickview-option-values">';
        values.forEach(function(val){
          var active = val === sel ? ' is-active' : '';
          optionsHtml += '<button type="button" class="quickview-optval' + active + '" data-opt-index="' + idx + '" data-opt-value="' + qvEsc(val) + '">' + qvEsc(val) + '</button>';
        });
        optionsHtml += '</div></div>';
      });
    }

    var desc = (p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (desc.length > 220) desc = desc.slice(0,220).replace(/\s+\S*$/, '') + '\u2026';

    var priceBlock = '<div class="quickview-prices"><span class="quickview-price">' + qvMoney(price) + '</span>'
      + (hasSale ? '<span class="quickview-rrp">RRP <s>' + qvMoney(compare) + '</s></span>' : '') + '</div>';

    var available = v && v.available;
    var btnLabel = available ? 'Add to cart' : 'Sold out';

    body.innerHTML =
      '<div class="quickview-grid">'
      + '<div class="quickview-media">' + (img ? '<img id="quickViewImg" src="' + qvEsc(img) + '" alt="' + qvEsc(p.title) + '">' : '<div class="quickview-noimg"></div>') + '</div>'
      + '<div class="quickview-info">'
      + (p.vendor ? '<div class="quickview-vendor">' + qvEsc(p.vendor) + '</div>' : '')
      + '<h2 class="quickview-title" id="quickViewTitle">' + qvEsc(p.title) + '</h2>'
      + '<div id="quickViewPriceWrap">' + priceBlock + '</div>'
      + optionsHtml
      + (desc ? '<p class="quickview-desc">' + qvEsc(desc) + '</p>' : '')
      + '<div class="quickview-actions">'
      + '<button type="button" class="quickview-add" id="quickViewAdd"' + (available ? '' : ' disabled') + '>' + btnLabel + '</button>'
      + '<a class="quickview-fulllink" href="' + themeRoute('products/' + encodeURIComponent(p.handle)) + (v ? '?variant=' + v.id : '') + '">View full details</a>'
      + '</div>'
      + '</div></div>';

    // Wire option buttons
    body.querySelectorAll('.quickview-optval').forEach(function(btn){
      btn.addEventListener('click', function(){
        var idx = parseInt(btn.getAttribute('data-opt-index'),10);
        var val = btn.getAttribute('data-opt-value');
        var sel = (qvState.variant ? qvState.variant.options.slice() : []);
        sel[idx] = val;
        var match = variantFromSelections(p, sel) || qvState.variant;
        qvState.variant = match;
        renderQuickView(p); // re-render to reflect new selection
      });
    });

    var addBtn = document.getElementById('quickViewAdd');
    if (addBtn){
      addBtn.addEventListener('click', function(){
        if (!qvState.variant || !qvState.variant.available) return;
        addBtn.textContent = 'Adding\u2026'; addBtn.disabled = true;
        fetch(themeRoute('cart/add.js'), {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ id: qvState.variant.id, quantity: 1 })
        })
        .then(function(res){ return res.json().then(function(d){ if(!res.ok) throw new Error(d.description||'error'); return d; }); })
        .then(function(){
          addBtn.textContent = 'Added!';
          if (typeof refreshCart === 'function') refreshCart();
          setTimeout(function(){ closeQuickView(); if (typeof toggleCart==='function') toggleCart(); }, 500);
        })
        .catch(function(){ addBtn.textContent = 'Unavailable'; setTimeout(function(){ addBtn.textContent='Add to cart'; addBtn.disabled=false; }, 2000); });
      });
    }
  }

  // Close on overlay backdrop click + Escape
  document.addEventListener('click', function(e){
    var ov = overlay();
    if (ov && ov.classList.contains('is-open') && e.target === ov) closeQuickView();
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape'){ var ov = overlay(); if (ov && ov.classList.contains('is-open')) closeQuickView(); }
  });
})();

/* ===== Accessibility: keep keyboard focus inside an open overlay (focus trap).
   Contained global Tab handler — no-op unless one of the overlays is open. ===== */
(function(){
  var OVERLAYS = [
    { sel: '#cartDrawer',        cls: 'open' },
    { sel: '#rangeDrawer',       cls: 'open' },
    { sel: '#quickViewOverlay',  cls: 'is-open' },
    { sel: '#signupPopupOverlay', cls: 'visible' }
  ];
  function activeOverlay(){
    for (var i = 0; i < OVERLAYS.length; i++){
      var el = document.querySelector(OVERLAYS[i].sel);
      if (el && el.classList.contains(OVERLAYS[i].cls)) return el;
    }
    return null;
  }
  function focusable(container){
    var nodes = container.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function(n){
      return n.offsetParent !== null && !n.hasAttribute('hidden');
    });
  }
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Tab') return;
    var overlay = activeOverlay();
    if (!overlay) return;
    var f = focusable(overlay);
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!overlay.contains(document.activeElement)){ e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });
})();

/* ===== Judge.me: hide any duplicate review widget that renders OUTSIDE the
   theme's own reviews accordion. Structural + ID-independent, so it still works
   if the app-block section ID changes (the CSS rule in theme.liquid is only a
   fast-path for the current ID). Never touches the theme's own widget or the
   preview badge, and never hides the product section itself. ===== */
(function(){
  if (!/\/products\//.test(location.pathname)) return;
  function sweep(){
    var accordion = document.getElementById('reviewsAccordionContent');
    var widgets = document.querySelectorAll('.jdgm-review-widget, .jdgm-rev-widg, .jdgm-all-reviews-widget');
    for (var i = 0; i < widgets.length; i++){
      var w = widgets[i];
      if (accordion && accordion.contains(w)) continue; // keep the theme's own reviews
      var section = w.closest('.shopify-section');
      if (section && !section.querySelector('#reviewsAccordionContent')) {
        section.style.display = 'none';        // stray app-block section — collapse it
      } else {
        w.style.display = 'none';              // stray widget inside a shared section — hide just the widget
      }
    }
  }
  document.addEventListener('DOMContentLoaded', function(){
    sweep();
    if (typeof MutationObserver === 'function'){
      var obs = new MutationObserver(sweep);
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(function(){ obs.disconnect(); }, 8000); // Judge.me loads async; stop watching once it settles
    } else {
      setTimeout(sweep, 2000); setTimeout(sweep, 5000);
    }
  });
})();
